jQuery(document).ready(function ($) {
	// Select all headings within the .center-column-section, excluding h1
	var headings = $('.center-column-section').find('h2, h3, h4, h5, h6');

	// Create a root unordered list to hold the hierarchical structure
	var rootList = $('<ul>');

	// Loop through each heading and append to the hierarchical list
	headings.each(function (index) {
		// Get the heading level (h2, h3, h4, etc.)
		var level = $(this).prop('tagName').toLowerCase();

		// Get the text content of the heading
		var text = $(this).text();

		// Generate a unique ID for the heading
		var headingID = 'heading_' + index;

		// Add the ID to the heading
		$(this).attr('id', headingID);

		// Create a list item for the heading with an anchor link
		var listItem = $('<li>').html('<a href="#' + headingID + '">' + text + '</a>');

		// Determine the parent list based on the heading level
		var parentList = rootList;
		for (var i = 2; i < parseInt(level.charAt(1)); i++) {
			// Create nested lists if necessary
			var sublist = parentList.children('li:last-child').children('ul');
			if (sublist.length === 0) {
				sublist = $('<ul>');
				parentList.children('li:last-child').append(sublist);
			}
			parentList = sublist;
		}

		// Append the list item to the parent list
		parentList.append(listItem);
	});

	// Append the root list to the #outputContainer
	$('#outputContainer').append(rootList);

	// Smooth scroll when clicking on anchor links
	// $('a').on('click', function(event) {
	//   if (this.hash !== '') {
	//     event.preventDefault();

	//     var hash = this.hash;

	//     // Scroll smoothly to the target heading
	//     $('html, body').animate({
	//       scrollTop: $(hash).offset().top
	//     }, 800);
	//   }
	// });
	$('a').on('click', function (event) {
		if (this.hash !== '' && this.hash !== '#recover') {
			event.preventDefault();

			var hash = this.hash;

			// Calculate the offset top of the target element and subtract 75 pixels
			var targetOffset = $(hash).offset().top - 80;

			// Scroll smoothly to the adjusted target position
			$('html, body').animate({
				scrollTop: targetOffset
			}, 800);
		}
	});

	// // Select the element with id="single-article-sidebar-top-articles"
	// var $sidebarTopArticles = jQuery('#single-article-sidebar-top-articles');

	// // Select the element with id="related-random-products-section"
	// var $relatedRandomProductsSection = jQuery('#related-random-products-section');

	// // Move the element with id="single-article-sidebar-top-articles" before the element with id="related-random-products-section"
	// $sidebarTopArticles.insertBefore($relatedRandomProductsSection);

});

jQuery(document).ready(function ($) {
	// Function to move sidebar top articles before related random products section
	function moveSidebarTopArticles() {
		// Select the element with id="single-article-sidebar-top-articles"
		var $sidebarTopArticles = $('#single-article-sidebar-top-articles');

		// Select the element with id="related-random-products-section"
		var $relatedRandomProductsSection = $('#related-random-products-section');

		// Move the element with id="single-article-sidebar-top-articles" before the element with id="related-random-products-section"
		$sidebarTopArticles.insertBefore($relatedRandomProductsSection);
		$sidebarTopArticles.show();
	}

	// Check window width on page load
	if ($(window).width() < 1024) {
		// Call the function to move sidebar top articles
		moveSidebarTopArticles();
	}

	// Recheck window width when window is resized
	$(window).resize(function () {
		if ($(window).width() < 1024) {
			// Call the function to move sidebar top articles
			moveSidebarTopArticles();
		}
	});
});


window.theme = window.theme || {}, window.slate = window.slate || {}, window.lazySizesConfig = window.lazySizesConfig || {}, lazySizesConfig.expFactor = 4, $(".go-top").click(function () {
	$("html").animate({
		scrollTop: 0
	}, 500)
});
localStorage.setItem("exchangeRate_eur", 1);
localStorage.setItem("exchangeRate_gbp", 1);
localStorage.setItem("exchangeRate_cad", 1 * 1.195 * 1.357);
localStorage.setItem("exchangeRate_aed", 1 * 1.25 * 3.67);
let scrollFun = throttle(toggleTop, 500);
setTimeout(() => {
	const clickEvent = new MouseEvent('click', {
		view: window,
		bubbles: true,
		cancelable: true
	});
	let footerdiv = document.getElementsByClassName("site-footer")[0];
	let footerbut = footerdiv.querySelectorAll(".collapsible-trigger-btn");
	for (let fdom of footerbut) {
		fdom.dispatchEvent(clickEvent)
	}
}, 1000);
(function () {
	let arr, reg = new RegExp("(^| )cart_currency=([^;]*)(;|$)");
	arr = document.cookie.match(reg);
	const currency = unescape(arr[2]);
	let classdom = document.getElementsByClassName("exchangeRate");
	let exchangeRate = 1;
	if (currency === "EUR") {
		exchangeRate = Number(localStorage.getItem("exchangeRate_eur"));
		for (let i = 0; i < classdom.length; i++) {
			classdom[i].innerText = "€" + (Number(classdom[i].innerText.substr(1)) * exchangeRate).toFixed(2)
		}
	} else if (currency === "GBP") {
		exchangeRate = Number(localStorage.getItem("exchangeRate_gbp"));
		for (let i = 0; i < classdom.length; i++) {
			classdom[i].innerText = "£" + (Number(classdom[i].innerText.substr(1)) * exchangeRate).toFixed(2)
		}
	} else if (currency === "CAD") {
		exchangeRate = Number(localStorage.getItem("exchangeRate_cad"));
		for (let i = 0; i < classdom.length; i++) {
			classdom[i].innerText = "CA$" + Math.trunc(Number(classdom[i].innerText.substr(1)) * exchangeRate) + '.99'
		}
	} else if (currency === "AED") {
		exchangeRate = Number(localStorage.getItem("exchangeRate_aed"));
		for (let i = 0; i < classdom.length; i++) {
			classdom[i].innerText = "Dhs. " + Math.trunc(Number(classdom[i].innerText.substr(1)) * exchangeRate) + '.99'
		}
	}
})();

function toggleTop() {
	$(window).scrollTop() > 100 ? $(".go-top").fadeIn() : $(".go-top").fadeOut()
}

function throttle(t, e) {
	let n;
	return function () {
		let a = this,
			o = arguments;
		n || (n = setTimeout(() => {
			n = null, t.apply(a, o)
		}, e))
	}
}
$(window).scroll(function () {
	scrollFun()
});
var mySwiper6 = new Swiper(".swiper-container6", {
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	}
}),
	swiper5 = new Swiper(".swiper-container5", {
		observer: !0,
		observeParents: !0,
		pagination: {
			el: ".swiper-pagination"
		},
		autoplay: {
			delay: 3e3,
			disableOnInteraction: !1
		},
		loop: !0
	});
$(".block-flex .product").eq(0).click(function () {
	window.location.href = "https://www.level8cases.com/products/new-level8-gibraltar-full-aluminum-carry-on-luggage-20?WZSYC1"
}), $(".block-flex .product").eq(1).click(function () {
	window.location.href = "https://www.level8cases.com/collections/all-products/products/large-luggage-with-wide-handle-level8-voyageur?WZSYC3"
}), $(".block-flex .product").eq(2).click(function () {
	window.location.href = "https://www.level8cases.com/products/elegance-trunk-luggage-28?WZSYC2"
}), $(window).width() >= 790 ? ($(".product__photos").removeClass("product__photos--below").addClass("product__photos--beside"), $(".product__thumbs").removeClass(" product__thumbs--below").addClass(" product__thumbs--beside").attr("data-position", "beside"), $(".swiper-container5").find(".swiper-wrapper").html(`<div class="swiper-slide pc-swiper"><img src="https://level8cases.oss-cn-hangzhou.aliyuncs.com/995e6e17-9972-43a3-b50a-89cda19a2237.png"alt="111222"class="img-responsive"></div><div class="swiper-slide pc-swiper"><img src="https://level8cases.oss-cn-hangzhou.aliyuncs.com/bad972f7-edf4-43f7-b3ea-471d04e3d1af.png"alt="111222"class="img-responsive"></div><div class="swiper-slide pc-swiper"><img src="https://level8cases.oss-cn-hangzhou.aliyuncs.com/2d09b73d-38c6-40ca-b09b-c8dcbed3e8de.png"alt="111222"class="img-responsive"></div>`)) : $(".swiper-container5").find(".swiper-wrapper").html(`<div class="swiper-slide"><img src="https://level8cases.oss-cn-hangzhou.aliyuncs.com/971ca580-9053-4dde-b2ae-5b8a833324f1.jpg"alt="111222"class="img-responsive"></div><div class="swiper-slide"><img src="https://level8cases.oss-cn-hangzhou.aliyuncs.com/dabd761d-2a89-447d-a60a-ddd414cd2e71.jpg"alt="111222"class="img-responsive"></div><div class="swiper-slide"><img src="https://level8cases.oss-cn-hangzhou.aliyuncs.com/54537ce3-5c24-4605-99c8-98612dd2e1ab.jpg"alt="111222"class="img-responsive"></div>`), $($(".collapsibles-wrapper").children("div").get(0)).addClass("is-open").css("height", "auto"), $($(".collapsibles-wrapper").children("button").get(0)).addClass("is-open"), $($(".site-navigation").find(".site-nav__item")[2]).find("a").css("color", "inherit"), $(".mobile-nav").children(".mobile-nav__item").eq(0).find(".menu-red-icon").eq(0).css("display", "block"), $(".mobile-nav").children(".mobile-nav__item").eq(2).find("a").css("color", "inherit"), $(".friday-cart-icon").mouseenter(function () {
	$(this).attr("src", "https://level8cases.oss-cn-hangzhou.aliyuncs.com/d2e0658a-3796-43a3-92b1-f38eea641fae.png")
}), $(".friday-cart-icon").mouseleave(function () {
	$(this).attr("src", "https://level8cases.oss-cn-hangzhou.aliyuncs.com/ea81ea5a-be8f-4e7d-95fd-f2357ab8a824.png")
}), $("#go-reviews").on("click", function () {
	$("#shopify-ali-review").hasClass("un-scroll") || $("html,body").animate({
		scrollTop: $("#shopify-ali-review").offset().top
	}, "slow")
}), $(".clickReturn").click(function () {
	$("#product-return").toggleClass("is-open return-height"), $(this).toggleClass("border-bottom")
}), $(".a-link").css("cursor", "pointer"), $(".a-link").click(function () {
	window.location.replace("https://www.level8cases.com/pages/all-saints-day")
});
let productColors = document.getElementsByClassName("grid-product__colors");
if (0 !== productColors.length)
	for (let i = 0; i < productColors.length; i++)
		for (let j = 0; j < productColors[i].children.length; j++) productColors[i].children[0].classList.add("swatch-noborder");

function setGridH() {
	$.each($(".grid"), function (t, e) {
		let n = 0;
		t !== $(".grid").length - 1 && ($(this).find(".grid-product ").each(function () {
			$(this).height() > n && (n = $(this).height())
		}), $(this).find(".grid-product").each(function () {
			$(this).height(n)
		}))
	})
}

function setPH() {
	$.each($(".grid"), function (t, e) {
		let n = 0;
		t !== $(".grid").length - 1 && ($(this).find(".product-text ").each(function () {
			$(this).height() > n && (n = $(this).height())
		}), $(this).find(".product-text").each(function () {
			$(this).height(n)
		}))
	})
}

function changeNum() {
	let t = document.getElementsByClassName("my-price"),
		e = document.getElementsByClassName("cart__product-qty"),
		n = 0,
		a = 0,
		o = 0,
		s = !1;
	o = (e[e.length - 1].value - 1) * .01, e.length > 1 && (s = !0);
	for (let r = 0; r < e.length; r++) e[r].value > 1 && (s = !0), console.log(e[r]), console.log(t[r]), n += e[r].value * parseFloat(t[r].innerText.substring(1));
	a = n / 1, void 0 !== document.getElementsByClassName("cart__savings")[0] ? s ? ($(".cart__savings").css("display", "block"), document.getElementsByClassName("cart__savings")[0].innerText = "You're saving $" + (a - n).toFixed(2), document.getElementById("bk-cart-subtotal-price").innerText = "$" + (n.toFixed(2) - o).toFixed(2)) : (200 == a && (a -= .01), $(document.getElementsByClassName("cart__savings")[0]).css("display", "none"), document.getElementById("bk-cart-subtotal-price").innerText = "$" + (a.toFixed(2) - o).toFixed(2)) : s ? document.getElementById("bk-cart-subtotal-price").innerText = "$" + (1 * n).toFixed(2) : (console.log(n), document.getElementById("bk-cart-subtotal-price").innerText = "$" + (n.toFixed(2) - o).toFixed(2))
}

// changeNum .9 九折优惠

function formatNum(t) {
	var e = "",
		n = 0;
	if (-1 == t.indexOf(".")) {
		for (var a = t.length - 1; a >= 0; a--) n % 3 == 0 && 0 != n ? (total_p.toFixed(2), e = t.charAt(a) + "," + e) : e = t.charAt(a) + e, n++;
		t = e + ".00"
	} else {
		for (var a = t.indexOf(".") - 1; a >= 0; a--) e = n % 3 == 0 && 0 != n ? t.charAt(a) + "," + e : t.charAt(a) + e, n++;
		t = e + (t + "00").substr((t + "00").indexOf("."), 3)
	}
	return t
}
setGridH(), $(".add-btn").click(function () {
	let t = $(this).siblings("input").val();
	$(this).siblings("input").val(++t), changeNum()
}), $(".reduce-btn").click(function () {
	let t = $(this).siblings("input").val();
	t > 0 && $(this).siblings("input").val(--t), changeNum()
});
let addToCartBtn = document.getElementsByClassName("fixed-add-to-cart");
! function (t) {
	var t = jQuery = t;
	slate.utils = {
		defaultTo: function (t, e) {
			return null == t || t != t ? e : t
		}
	}, slate.a11y = {
		pageLinkFocus: function (t) {
			var e = "js-focus-hidden";
			t.first().attr("tabIndex", "-1").focus().addClass(e).one("blur", function n() {
				t.first().removeClass(e).removeAttr("tabindex")
			})
		},
		focusHash: function () {
			var e = window.location.hash;
			e && document.getElementById(e.slice(1)) && this.pageLinkFocus(t(e))
		},
		bindInPageLinks: function () {
			t("a[href*=#]").on("click", (function (e) {
				this.pageLinkFocus(t(e.currentTarget.hash))
			}).bind(this))
		},
		trapFocus: function (e) {
			var n = e.namespace ? "focusin." + e.namespace : "focusin";
			e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), t(document).off("focusin"), t(document).on(n, function (t) {
				e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus()
			})
		},
		removeTrapFocus: function (e) {
			var n = e.namespace ? "focusin." + e.namespace : "focusin";
			e.$container && e.$container.length && e.$container.removeAttr("tabindex"), t(document).off(n)
		},
		lockMobileScrolling: function (e, n) {
			if (n) var a = n;
			else var a = t(document.documentElement).add("body");
			a.on("touchmove" + e, function () {
				return !1
			})
		},
		unlockMobileScrolling: function (e, n) {
			if (n) var a = n;
			else var a = t(document.documentElement).add("body");
			a.off(e)
		}
	}, theme.Sections = function e() {
		this.constructors = {}, this.instances = [], t(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
	}, theme.Sections.prototype = t.extend({}, theme.Sections.prototype, {
		createInstance: function (e, n) {
			var a = t(e),
				o = a.attr("data-section-id"),
				s = a.attr("data-section-type");
			if (void 0 !== (n = n || this.constructors[s])) {
				var r = t.extend(new n(e), {
					id: o,
					type: s,
					container: e
				});
				this.instances.push(r)
			}
		},
		_onSectionLoad: function (e, n, a) {
			AOS && AOS.refreshHard();
			var o = n || t("[data-section-id]", e.target)[0];
			if (o) {
				this.createInstance(o);
				var s = n ? a : this._findInstance(e.detail.sectionId);
				n || this._loadSubSections(), s && "function" == typeof s.onLoad && s.onLoad(e)
			}
		},
		_loadSubSections: function () {
			AOS && AOS.refreshHard(), t("[data-subsection]").each((function (e, n) {
				this._onSectionLoad(null, n, t(n).data("section-d"))
			}).bind(this))
		},
		_onSectionUnload: function (t) {
			var e = this._removeInstance(t.detail.sectionId);
			e && "function" == typeof e.onUnload && e.onUnload(t)
		},
		_onSelect: function (t) {
			var e = this._findInstance(t.detail.sectionId);
			e && "function" == typeof e.onSelect && e.onSelect(t)
		},
		_onDeselect: function (t) {
			var e = this._findInstance(t.detail.sectionId);
			e && "function" == typeof e.onDeselect && e.onDeselect(t)
		},
		_onBlockSelect: function (t) {
			var e = this._findInstance(t.detail.sectionId);
			e && "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
		},
		_onBlockDeselect: function (t) {
			var e = this._findInstance(t.detail.sectionId);
			e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
		},
		_findInstance: function (t) {
			for (var e = 0; e < this.instances.length; e++)
				if (this.instances[e].id === t) return this.instances[e]
		},
		_removeInstance: function (t) {
			for (var e, n = this.instances.length; n--;)
				if (this.instances[n].id === t) {
					e = this.instances[n], this.instances.splice(n, 1);
					break
				} return e
		},
		register: function (e, n) {
			this.constructors[e] = n, t("[data-section-type=" + e + "]").each((function (t, e) {
				this.createInstance(e, n)
			}).bind(this))
		}
	}), theme.Currency = {
		formatMoney: function t(e, n) {
			"string" == typeof e && (e = e.replace(".", ""));
			var a = "",
				o = /\{\{\s*(\w+)\s*\}\}/,
				s = n || "$";

			function r(t, e, n, a) {
				if (e = slate.utils.defaultTo(e, 2), n = slate.utils.defaultTo(n, ","), a = slate.utils.defaultTo(a, "."), isNaN(t) || null == t) return 0;
				var o, s = (t = (t / 100).toFixed(e)).split(".");
				return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (s[1] ? a + s[1] : "")
			}
			switch (s.match(o)[1]) {
				case "amount":
					a = r(e, 2);
					break;
				case "amount_no_decimals":
					a = r(e, 0);
					break;
				case "amount_with_comma_separator":
					a = r(e, 2, ".", ",");
					break;
				case "amount_no_decimals_with_comma_separator":
					a = r(e, 0, ".", ",");
					break;
				case "amount_no_decimals_with_space_separator":
					a = r(e, 0, " ")
			}
			return s.replace(o, a)
		}
	}, theme.Images = {
		imageSize: function t(e) {
			if (!e) return "620x";
			var n = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
			return null !== n ? n[1] : null
		},
		getSizedImageUrl: function t(e, n) {
			if (null == n) return e;
			if ("master" === n) return this.removeProtocol(e);
			var a = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
			if (null != a) {
				var o = e.split(a[0]),
					s = a[0];
				return this.removeProtocol(o[0] + "_" + n + s)
			}
			return null
		},
		removeProtocol: function t(e) {
			return e.replace(/http(s)?:/, "")
		}
	}, slate.Variants = function () {
		function e(e) {
			this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), t(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
		}
		return e.prototype = t.extend({}, e.prototype, {
			_getCurrentOptions: function () {
				var e = t.map(t(this.singleOptionSelector, this.$container), function (e) {
					var n = t(e),
						a = n.attr("type"),
						o = {};
					return "radio" !== a && "checkbox" !== a ? (o.value = n.val(), o.index = n.data("index"), o) : !!n[0].checked && (o.value = n.val(), o.index = n.data("index"), o)
				});
				return this._compact(e)
			},
			_getVariantFromOptions: function () {
				var t = this._getCurrentOptions(),
					e = this.product.variants,
					n = !1;
				return e.forEach(function (e) {
					var a = !0;
					e.options, t.forEach(function (t) {
						a && (a = e[t.index] === t.value)
					}), a && (n = e)
				}), n || null
			},
			_onSelectChange: function () {
				var t = this._getVariantFromOptions();
				this.$container.trigger({
					type: "variantChange",
					variant: t
				}), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
			},
			_updateImages: function (t) {
				var e = t.featured_image || {},
					n = this.currentVariant.featured_image || {};
				t.featured_image && e.src !== n.src && this.$container.trigger({
					type: "variantImageChange",
					variant: t
				})
			},
			_updatePrice: function (t) {
				(t.price !== this.currentVariant.price || t.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({
					type: "variantPriceChange",
					variant: t
				})
			},
			_updateSKU: function (t) {
				t.sku !== this.currentVariant.sku && this.$container.trigger({
					type: "variantSKUChange",
					variant: t
				})
			},
			_updateHistoryState: function (t) {
				if (history.replaceState && t) {
					var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
					window.history.replaceState({
						path: e
					}, "", e)
				}
			},
			_updateMasterSelect: function (e) {
				t(this.originalSelectorId, this.$container).val(e.id)
			},
			_compact: function (t) {
				for (var e = -1, n = null == t ? 0 : t.length, a = 0, o = []; ++e < n;) {
					var s = t[e];
					s && (o[a++] = s)
				}
				return o
			}
		}), e
	}(), slate.rte = {
		wrapTable: function () {
			t(".rte table").wrap('<div class="table-wrapper"></div>')
		},
		wrapVideo: function () {
			var e = t('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
				n = e.add("iframe#admin_bar_iframe");
			e.each(function () {
				t(this).parents(".video-wrapper").length || t(this).wrap('<div class="video-wrapper"></div>')
			}), n.each(function () {
				this.src = this.src
			})
		}
	}, theme.Modals = function () {
		function e(e, n, a) {
			if (this.id = e, this.$modal = t("#" + e), !this.$modal.length) return !1;
			this.nodes = {
				$parent: t("html").add("body"),
				$modalContent: this.$modal.find(".modal__inner")
			}, this.config = t.extend({
				close: ".js-modal-close",
				open: ".js-modal-open-" + n,
				openClass: "modal--is-active",
				closingClass: "modal--is-closing",
				bodyOpenClass: "modal-open",
				bodyOpenSolidClass: "modal-open--solid",
				bodyClosingClass: "modal-closing",
				closeOffContentClick: !0
			}, a), this.modalIsOpen = !1, this.$focusOnOpen = this.config.focusOnOpen ? t(this.config.focusOnOpen) : this.$modal, this.isSolid = this.config.solid, this.init()
		}
		return e.prototype.init = function () {
			t(this.config.open).attr("aria-expanded", "false"), t(this.config.open).on("click", this.open.bind(this)), this.$modal.find(this.config.close).on("click", this.close.bind(this)), t("body").on("drawerOpen", (function () {
				this.close()
			}).bind(this))
		}, e.prototype.open = function (e) {
			var n = !1;
			!this.modalIsOpen && (e ? e.preventDefault() : n = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = t(e.currentTarget)), this.modalIsOpen && !n && this.close(), this.$modal.prepareTransition().addClass(this.config.openClass), this.nodes.$parent.addClass(this.config.bodyOpenClass), this.isSolid && this.nodes.$parent.addClass(this.config.bodyOpenSolidClass), this.modalIsOpen = !0, slate.a11y.trapFocus({
				$container: this.$modal,
				$elementToFocus: this.$focusOnOpen,
				namespace: "modal_focus"
			}), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), t("body").trigger("modalOpen." + this.id), this.bindEvents())
		}, e.prototype.close = function () {
			if (this.modalIsOpen) {
				t(document.activeElement).trigger("blur"), this.$modal.prepareTransition().removeClass(this.config.openClass).addClass(this.config.closingClass), this.nodes.$parent.removeClass(this.config.bodyOpenClass), this.nodes.$parent.addClass(this.config.bodyClosingClass);
				var e = this;
				window.setTimeout(function () {
					e.nodes.$parent.removeClass(e.config.bodyClosingClass), e.$modal.removeClass(e.config.closingClass)
				}, 500), this.isSolid && this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass), this.modalIsOpen = !1, slate.a11y.removeTrapFocus({
					$container: this.$modal,
					namespace: "modal_focus"
				}), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(), t("body").trigger("modalClose." + this.id), this.unbindEvents()
			}
		}, e.prototype.bindEvents = function () {
			this.nodes.$parent.on("keyup.modal", (function (t) {
				27 === t.keyCode && this.close()
			}).bind(this)), this.config.closeOffContentClick && (this.$modal.on("click.modal", this.close.bind(this)), this.nodes.$modalContent.on("click.modal", function (t) {
				t.stopImmediatePropagation()
			}))
		}, e.prototype.unbindEvents = function () {
			this.nodes.$parent.off(".modal"), this.config.closeOffContentClick && (this.$modal.off(".modal"), this.nodes.$modalContent.off(".modal"))
		}, e
	}(), theme.Drawers = function () {
		function e(e, n) {
			if (this.config = {
				id: e,
				close: ".js-drawer-close",
				open: ".js-drawer-open-" + n,
				openClass: "js-drawer-open",
				closingClass: "js-drawer-closing",
				activeDrawer: "drawer--is-open",
				namespace: ".drawer-" + n
			}, this.$nodes = {
				parent: t(document.documentElement).add("body"),
				page: t("#MainContent")
			}, this.$drawer = t("#" + e), !this.$drawer.length) return !1;
			this.isOpen = !1, this.init()
		}
		return e.prototype = t.extend({}, e.prototype, {
			init: function () {
				var e = t(this.config.open);
				e.attr("aria-expanded", "false"), e.on("click", this.open.bind(this)), this.$drawer.find(this.config.close).on("click", this.close.bind(this))
			},
			open: function (e) {
				e && e.preventDefault(), !this.isOpen && (e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = t(e.currentTarget)), this.$drawer.prepareTransition().addClass(this.config.activeDrawer), this.$nodes.parent.addClass(this.config.openClass), this.isOpen = !0, slate.a11y.trapFocus({
					$container: this.$drawer,
					namespace: "drawer_focus"
				}), t("body").trigger("drawerOpen." + this.config.id), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents())
			},
			close: function () {
				if (this.isOpen) {
					t(document.activeElement).trigger("blur"), this.$drawer.prepareTransition().removeClass(this.config.activeDrawer), this.$nodes.parent.removeClass(this.config.openClass), this.$nodes.parent.addClass(this.config.closingClass);
					var e = this;
					window.setTimeout(function () {
						e.$nodes.parent.removeClass(e.config.closingClass)
					}, 500), this.isOpen = !1, slate.a11y.removeTrapFocus({
						$container: this.$drawer,
						namespace: "drawer_focus"
					}), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"), this.unbindEvents()
				}
			},
			bindEvents: function () {
				slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.page.on("click" + this.config.namespace, (function () {
					return this.close(), !1
				}).bind(this)), this.$nodes.parent.on("keyup" + this.config.namespace, (function (t) {
					27 === t.keyCode && this.close()
				}).bind(this))
			},
			unbindEvents: function () {
				slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.parent.off(this.config.namespace), this.$nodes.page.off(this.config.namespace)
			}
		}), e
	}(), theme.cart = {
		getCart: function () {
			return t.getJSON("/cart.js")
		},
		changeItem: function (t, e) {
			return this._updateCart({
				type: "POST",
				url: "/cart/change.js",
				data: "quantity=" + e + "&id=" + t,
				dataType: "json"
			})
		},
		addItemFromForm: function (t) {
			return this._updateCart({
				type: "POST",
				url: "/cart/add.js",
				data: t,
				dataType: "json"
			})
		},
		_updateCart: function (e) {
			return t.ajax(e).then((function (t) {
				return t
			}).bind(this))
		},
		updateNote: function (e) {
			var n = {
				type: "POST",
				url: "/cart/update.js",
				data: "note=" + theme.cart.attributeToString(e),
				dataType: "json",
				success: function (t) { },
				error: function (t, e) { }
			};
			t.ajax(n)
		},
		attributeToString: function (e) {
			return "string" != typeof e && "undefined" == (e += "") && (e = ""), t.trim(e)
		}
	}, t(function () {
		t("body").on("click", ".cart__checkout", function () {
			t(this).addClass("btn--loading")
		}), t("body").on("change", 'textarea[name="note"]', function () {
			var e = t(this).val();
			theme.cart.updateNote(e)
		}), t("body").on("click", ".cart__checkout--ajax", function (e) {
			if (!t("#CartAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), t(this).removeClass("btn--loading"), !1
		}), t("body").on("click", ".cart__checkout--page", function (e) {
			if (!t("#CartPageAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), t(this).removeClass("btn--loading"), !1
		})
	}), theme.QtySelector = function () {
		var e = {
			input: ".js-qty__num",
			plus: ".js-qty__adjust--plus",
			minus: ".js-qty__adjust--minus"
		};

		function n(n, a) {
			this.$wrapper = n, this.$originalInput = n.find('input[type="number"]'), this.minValue = this.$originalInput.attr("min") || 1, this.options = t.extend({
				namespace: null
			}, a), this.source = t("#JsQty").html(), this.template = Handlebars.compile(this.source);
			var o = {
				current: this._getOriginalQty(),
				add: this._getOriginalQty() + 1,
				minus: this._getOriginalQty() - 1
			};
			this.data = {
				key: this._getProductKey(),
				itemQty: o.current,
				itemAdd: o.add,
				itemMinus: o.minus,
				inputName: this._getInputName(),
				inputId: this._getId()
			}, this.$originalInput.after(this.template(this.data)).remove(), this.$input = this.$wrapper.find(e.input), this.$plus = this.$wrapper.find(e.plus), this.$minus = this.$wrapper.find(e.minus), this.initEventListeners()
		}
		return n.prototype = t.extend({}, n.prototype, {
			_getProductKey: function () {
				return this.$originalInput.data("id") || null
			},
			_getOriginalQty: function () {
				return parseInt(this.$originalInput.val())
			},
			_getInputName: function () {
				return this.$originalInput.attr("name")
			},
			_getId: function () {
				return this.$originalInput.attr("id")
			},
			initEventListeners: function () {
				this.$plus.on("click", (function () {
					var t = this.validateQty(this.$input.val());
					this.addQty(t)
				}).bind(this)), this.$minus.on("click", (function () {
					var t = this.validateQty(this.$input.val());
					this.subtractQty(t)
				}).bind(this)), this.$input.on("change", (function () {
					var t = this.validateQty(this.$input.val());
					this.changeQty(t)
				}).bind(this))
			},
			addQty: function (t) {
				this.changeQty(t + 1)
			},
			subtractQty: function (t) {
				var e = t - 1;
				e <= this.minValue && (e = this.minValue), this.changeQty(e)
			},
			changeQty: function (e) {
				this.$input.val(e), t("body").trigger("qty" + this.options.namespace, [this.data.key, e])
			},
			validateQty: function (t) {
				return (parseFloat(t) != parseInt(t) || isNaN(t)) && (t = 1), parseInt(t)
			}
		}), n
	}(), theme.CartDrawer = function () {
		var e = {
			namespace: ".ajaxcart"
		},
			n = {
				drawer: "#CartDrawer",
				container: "#CartContainer",
				template: "#CartTemplate",
				fixedFooter: ".drawer__footer--fixed",
				fixedInnerContent: ".drawer__inner--has-fixed-footer",
				cartBubble: ".cart-link__bubble"
			};

		function a() {
			this.status = {
				loaded: !1,
				loading: !1
			}, this.qtySelectors = [], this.drawer = new theme.Drawers("CartDrawer", "cart");
			var e = t(n.template).html();
			this.template = Handlebars.compile(e), theme.cart.getCart().then(this.buildCart.bind(this)), this.initEventListeners()
		}
		return a.prototype = t.extend({}, a.prototype, {
			initEventListeners: function () {
				t("body").on("updateCart" + e.namespace, this.initQtySelectors.bind(this)), t("body").on("updateCart" + e.namespace, this.sizeFooter.bind(this)), t("body").on("updateCart" + e.namespace, this.updateCartNotification.bind(this)), t("body").on("drawerOpen.CartDrawer", this.sizeFooter.bind(this)), t(window).on("resize" + e.namespace, t.debounce(150, this.sizeFooter.bind(this))), t("body").on("added.ajaxProduct", (function () {
					theme.cart.getCart().then((function (t) {
						this.buildCart(t, !0)
					}).bind(this))
				}).bind(this))
			},
			buildCart: function (a, o) {
				if (this.loading(!0), this.emptyCart(), 0 === a.item_count) t(n.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + "</p>");
				else {
					var s = [],
						r = {},
						c = {},
						d = 1;
					t.each(a.items, function (e, n) {
						var a;
						a = null !== n.image ? n.image.replace(/(\.[^.]*)$/, "_180x$1") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif", null !== n.properties && t.each(n.properties, function (t, e) {
							"_" !== t.charAt(0) && e || delete n.properties[t]
						}), d += 2, r = {
							key: n.key,
							url: n.url,
							img: a,
							animationRow: d,
							name: n.product_title,
							variation: n.variant_title,
							properties: n.properties,
							itemQty: n.quantity,
							price: theme.Currency.formatMoney(n.price, theme.settings.moneyFormat),
							discountedPrice: theme.Currency.formatMoney(n.price - n.total_discount / n.quantity, theme.settings.moneyFormat),
							discounts: n.discounts,
							discountsApplied: n.price !== n.price - n.total_discount,
							vendor: n.vendor
						}, s.push(r)
					}), d += 2, c = {
						items: s,
						note: a.note,
						lastAnimationRow: d,
						totalPrice: theme.Currency.formatMoney(a.total_price, theme.settings.moneyFormat),
						totalCartDiscount: 0 === a.total_discount ? 0 : theme.strings.cartSavings.replace("[savings]", theme.Currency.formatMoney(a.total_discount, theme.settings.moneyFormat))
					}, t(n.container).append(this.template(c))
				}
				this.status.loaded = !0, this.loading(!1), t("body").hasClass("currencies-enabled") && theme.currencySwitcher.ajaxrefresh(), t("body").trigger("updateCart" + e.namespace, a), window.Shopify && Shopify.StorefrontExpressButtons && (Shopify.StorefrontExpressButtons.initialize(), setTimeout((function () {
					this.sizeFooter()
				}).bind(this), 800)), !0 === o && this.drawer.open()
			},
			initQtySelectors: function () {
				this.qtySelectors = [], t(n.container).find(".js-qty").each((function (e, n) {
					var a = new theme.QtySelector(t(n), {
						namespace: ".cart-drawer"
					});
					this.qtySelectors.push(a)
				}).bind(this)), t("body").on("qty.cart-drawer", this.updateItem.bind(this))
			},
			updateItem: function (t, e, n) {
				!this.status.loading && (this.loading(!0), theme.cart.changeItem(e, n).then((function (t) {
					this.updateSuccess(t)
				}).bind(this)).catch((function (t) {
					this.updateError(t)
				}).bind(this)).always((function () {
					this.loading(!1)
				}).bind(this)))
			},
			loading: function (e) {
				this.status.loading = e, e ? t(n.container).addClass("is-loading") : t(n.container).removeClass("is-loading")
			},
			emptyCart: function () {
				t(n.container).empty()
			},
			updateSuccess: function (t) {
				this.buildCart(t)
			},
			updateError: function (t) {
				t.responseJSON && t.responseJSON.description && console.warn(t.responseJSON.description)
			},
			sizeFooter: function () {
				if (t(n.drawer).hasClass("drawer--has-fixed-footer")) {
					var e = t(n.drawer).find(n.fixedFooter).removeAttr("style"),
						a = t(n.drawer).find(n.fixedInnerContent).removeAttr("style"),
						o = e.outerHeight();
					a.css("bottom", o), e.css("height", o)
				}
			},
			updateCartNotification: function (e, a) {
				a.items.length > 0 ? t(n.cartBubble).addClass("cart-link__bubble--visible") : t(n.cartBubble).removeClass("cart-link__bubble--visible")
			}
		}), a
	}(), theme.AjaxProduct = function () {
		var e = {
			loading: !1
		};

		function n(t) {
			this.$form = t, this.$addToCart = this.$form.find(".add-to-cart"), this.$form.length && this.$form.on("submit", this.addItemFromForm.bind(this))
		}
		return n.prototype = t.extend({}, n.prototype, {
			addItemFromForm: function (t, n) {
				if (t.preventDefault(), e.loading) {
					console.warn("already adding item to cart | bail");
					return
				}
				this.$addToCart.addClass("btn--loading"), e.loading = !0;
				var a = this.$form.serialize();
				theme.cart.addItemFromForm(a).then((function (t) {
					this.success(t)
				}).bind(this)).catch((function (t) {
					this.error(t)
				}).bind(this)).always((function () {
					e.loading = !1, this.$addToCart.removeClass("btn--loading")
				}).bind(this))
			},
			success: function (e) {
				this.$form.find(".errors").remove(), t("body").trigger("added.ajaxProduct")
			},
			error: function (t) {
				this.$form.find(".errors").remove(), t.responseJSON && t.responseJSON.description && (console.warn(t.responseJSON.description), this.$form.prepend('<div class="errors text-center">' + t.responseJSON.description + "</div>"))
			}
		}), n
	}(), theme.collapsibles = function () {
		var e = {
			trigger: ".collapsible-trigger",
			module: ".collapsible-content",
			moduleInner: ".collapsible-content__inner"
		},
			n = {
				hide: "hide",
				open: "is-open",
				autoHeight: "collapsible--auto-height"
			},
			a = !1;

		function o(t, e, o, s) {
			if (t.removeClass(n.hide).prepareTransition().css("height", e).toggleClass(n.open, !o), !o && s) {
				var r = t;
				window.setTimeout(function () {
					r.css("height", "auto"), a = !1
				}, 500)
			} else a = !1
		}
		return {
			init: function s() {
				t(e.trigger).each(function () {
					var e = t(this),
						a = e.hasClass(n.open);
					e.attr("aria-expanded", a)
				}), t("body, .modal__inner").on("click", e.trigger, function () {
					if (!a) {
						a = !0;
						var s = t(this),
							r = s.hasClass(n.open),
							c = t("#" + s.attr("aria-controls")),
							d = c.find(e.moduleInner).outerHeight(),
							l = s.hasClass(n.autoHeight);
						r && l && setTimeout(function () {
							o(c, d = 0, r, l)
						}, 0), r && !l && (d = 0), s.attr("aria-expanded", !r).toggleClass(n.open, !r), o(c, d, r, l)
					}
				})
			}
		}
	}(), theme.headerNav = function () {
		var e, n, a, o, s, r, c = t(document.documentElement).add("body"),
			d = t("#MainContent"),
			l = {
				wrapper: ".header-wrapper",
				siteHeader: ".site-header",
				searchBtn: ".js-search-header",
				closeSearch: ".js-search-header-close",
				searchContainer: ".site-header__search-container",
				logoContainer: ".site-header__logo",
				logo: ".site-header__logo img",
				navigation: ".site-navigation",
				navContainerWithLogo: ".header-item--logo",
				navItems: ".site-nav__item",
				navLinks: ".site-nav__link",
				navLinksWithDropdown: ".site-nav__link--has-dropdown",
				navDropdownLinks: ".site-nav__dropdown-link--second-level"
			},
			u = {
				hasDropdownClass: "site-nav--has-dropdown",
				hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
				dropdownActive: "is-focused"
			},
			h = {
				namespace: ".siteNav",
				wrapperOverlayed: !1,
				overlayedClass: "is-light",
				stickyEnabled: !1,
				stickyActive: !1,
				stickyClass: "site-header--stuck",
				openTransitionClass: "site-header--opening",
				lastScroll: 0
			};

		function p() {
			t(document.activeElement).trigger("blur"), c.removeClass("js-drawer-open js-drawer-open--search").off(h.namespace), t(l.searchContainer).removeClass("is-active"), slate.a11y.removeTrapFocus({
				$container: t(l.searchContainer),
				namespace: "header_search"
			}), slate.a11y.unlockMobileScrolling(h.namespace), d.off("click" + h.namespace), c.off("keyup" + h.namespace)
		}

		function f() {
			t(l.logo).each(function () {
				var e = t(this),
					n = e.width(),
					a = e.closest(".grid__item").width();
				n > a ? e.css("maxWidth", a) : e.removeAttr("style")
			})
		}

		function m() {
			t(".site-header-sticky").css("height", r.outerHeight(!0))
		}

		function g() {
			var t = e.scrollTop();
			if (t > 250) {
				if (h.stickyActive) return;
				h.stickyActive = !0, r.addClass(h.stickyClass), h.wrapperOverlayed && s.removeClass(h.overlayedClass), setTimeout(function () {
					r.addClass(h.openTransitionClass)
				}, 100)
			} else {
				if (!h.stickyActive) return;
				h.stickyActive = !1, r.removeClass(h.openTransitionClass).removeClass(h.stickyClass), h.wrapperOverlayed && s.addClass(h.overlayedClass)
			}
			h.lastScroll = t
		}
		return {
			init: function v() {
				e = t(window), n = t(l.navContainerWithLogo), a = t(l.logoContainer), o = t(l.navigation), s = t(l.wrapper), r = t(l.siteHeader), h.stickyEnabled = r.data("sticky"), h.stickyEnabled && (h.wrapperOverlayed = s.hasClass(h.overlayedClass), h.lastScroll = 0, r.wrap('<div class="site-header-sticky"></div>'), m(), e.on("resize" + h.namespace, t.debounce(50, m)), e.on("scroll" + h.namespace, t.throttle(15, g)), Shopify && Shopify.designMode && setTimeout(function () {
					m()
				}, 250)),
					function e() {
						var n = !1,
							a = !1,
							o = !1;

						function s(e) {
							var a = e.parent();
							if (a.hasClass(u.hasDropdownClass) && (a.addClass(u.dropdownActive), n = !0), !theme.config.isTouch && !o) {
								var s = theme.config.isTouch ? "touchend" : "click";
								o = !0, t("body").on(s + h.namespace, function () {
									c(), t("body").off(h.namespace), o = !1
								})
							}
						}

						function r(t, e) {
							var n = t.parent();
							(n.hasClass(u.hasSubDropdownClass) || e) && (n.addClass(u.dropdownActive), a = !0)
						}

						function c() {
							d(), p()
						}

						function d() {
							t(l.navItems).removeClass(u.dropdownActive)
						}

						function p() {
							t(l.navDropdownLinks).parent().removeClass(u.dropdownActive)
						}
						theme.config.isTouch && (t(l.navLinksWithDropdown).on("touchend" + h.namespace, function (e) {
							var n = t(this);
							n.parent().hasClass(u.dropdownActive) ? window.location.replace(n.attr("href")) : (e.preventDefault(), c(), s(n))
						}), t(l.navDropdownLinks).on("touchend" + h.namespace, function (e) {
							var n = t(this),
								a = n.parent();
							a.hasClass(u.hasSubDropdownClass) ? a.hasClass(u.dropdownActive) ? window.location.replace(n.attr("href")) : (e.preventDefault(), p(), r(n)) : window.location.replace(n.attr("href"))
						})), t(l.navLinks).on("focusin mouseover" + h.namespace, function () {
							n && d(), a && p(), s(t(this))
						}), t(l.navLinks).on("mouseleave" + h.namespace, function () {
							c()
						}), t(l.navDropdownLinks).on("focusin" + h.namespace, function () {
							p(), r(t(this), !0)
						})
					}(), t(l.searchBtn).on("click" + h.namespace, function (e) {
						e.preventDefault(), t(l.searchContainer).addClass("is-active"), c.addClass("js-drawer-open js-drawer-open--search"), slate.a11y.trapFocus({
							$container: t(l.searchContainer),
							namespace: "header_search",
							$elementToFocus: t(l.searchContainer).find("input")
						}), theme.config.bpSmall && h.stickyEnabled && h.lastScroll < 300 && window.scrollTo(0, 0), slate.a11y.lockMobileScrolling(h.namespace), d.on("click" + h.namespace, function () {
							return p(), !1
						}), c.on("keyup" + h.namespace, function (t) {
							27 === t.keyCode && p()
						})
					}), t(l.closeSearch).on("click" + h.namespace, function () {
						p()
					}), e.on("load" + h.namespace, f), e.on("resize" + h.namespace, t.debounce(150, f))
			},
			unload: function e() {
				t(window).off(h.namespace), t(l.searchBtn).off(h.namespace), t(l.closeSearch).off(h.namespace), c.off(h.namespace), t(l.navLinks).off(h.namespace), t(l.navDropdownLinks).off(h.namespace)
			}
		}
	}(), theme.articleImages = function () {
		var e = {};

		function n() {
			e.$rteImages.find("img").each(function () {
				var n = t(this),
					a = n.attr("style");
				(!a || "float: none;" == a) && n.width() < e.$rteImages.width() && n.addClass("rte__no-indent")
			})
		}
		return {
			init: function a() {
				e.$rteImages = t(".rte--indented-images"), e.$rteImages.length && t(window).on("load", n)
			}
		}
	}(), theme.backButton = function () {
		function e() {
			var t = n(document.referrer);
			if (n(document.url) === t) return history.back(), !1
		}

		function n(t) {
			var e = document.createElement("a");
			return e.href = t, e.hostname
		}
		return {
			init: function e() {
				if (!document.referrer || !t(".return-link").length || !window.history.length) return
			}
		}
	}(), theme.Slideshow = function () {
		this.$slideshow = null;
		var e = {
			next: "is-next",
			init: "is-init",
			wrapper: "slideshow-wrapper",
			slideshow: "slideshow",
			currentSlide: "slick-current",
			pauseButton: "slideshow__pause",
			isPaused: "is-paused"
		};

		function n(n, a) {
			this.$slideshow = t(n), this.$wrapper = this.$slideshow.closest("." + e.wrapper), this.$pause = this.$wrapper.find("." + e.pauseButton), this.settings = {
				accessibility: !0,
				arrows: !!a.arrows,
				dots: !!a.dots,
				draggable: !0,
				touchThreshold: 5,
				pauseOnHover: !1,
				autoplay: this.$slideshow.data("autoplay"),
				autoplaySpeed: this.$slideshow.data("speed")
			}, this.$slideshow.on("init", this.init.bind(this)), this.$slideshow.slick(this.settings), this.$pause.on("click", this._togglePause.bind(this))
		}
		return n.prototype = t.extend({}, n.prototype, {
			init: function (t, n) {
				this.$slideshowList = n.$list, this.$slickDots = n.$dots, this.$allSlides = n.$slides, this.slideCount = n.slideCount, this.$slideshow.addClass(e.init), this._a11y(), this._clonedLazyloading()
			},
			destroy: function () {
				this.$slideshow.slick("unslick")
			},
			_play: function () {
				this.$slideshow.slick("slickPause"), t(e.pauseButton).addClass("is-paused")
			},
			_pause: function () {
				this.$slideshow.slick("slickPlay"), t(e.pauseButton).removeClass("is-paused")
			},
			_togglePause: function () {
				var n = this._getSlideshowId(this.$pause);
				this.$pause.hasClass(e.isPaused) ? (this.$pause.removeClass(e.isPaused), t(n).slick("slickPlay")) : (this.$pause.addClass(e.isPaused), t(n).slick("slickPause"))
			},
			_getSlideshowId: function (t) {
				return "#Slideshow-" + t.data("id")
			},
			_activeSlide: function () {
				return this.$slideshow.find(".slick-active")
			},
			_currentSlide: function () {
				return this.$slideshow.find(".slick-current")
			},
			_nextSlide: function (t) {
				return this.$slideshow.find('.slideshow__slide[data-slick-index="' + t + '"]')
			},
			_a11y: function () {
				var n = this.$slideshowList,
					a = this.settings.autoplay;
				n && (n.removeAttr("aria-live"), t(e.wrapper).on("focusin", (function (o) {
					t(e.wrapper).has(o.target).length && (n.attr("aria-live", "polite"), a && this._pause())
				}).bind(this)), t(e.wrapper).on("focusout", (function (o) {
					t(e.wrapper).has(o.target).length && (n.removeAttr("aria-live"), a && this._play())
				}).bind(this)))
			},
			_clonedLazyloading: function () {
				var e = this.$slideshow;
				e.find(".slick-slide").each((function (n, a) {
					var o = t(a);
					if (o.hasClass("slick-cloned")) {
						var s = o.data("id"),
							r = o.find(".hero__image").removeClass("lazyloading").addClass("lazyloaded");
						setTimeout(function () {
							var t = e.find(".slideshow__slide--" + s + ":not(.slick-cloned) .hero__image").attr("style");
							t && r.attr("style", t)
						}, this.settings.autoplaySpeed / 1.5)
					}
				}).bind(this))
			}
		}), n
	}(), theme.announcementBar = function () {
		var e = {
			announcementBar: ".announcement",
			announcementText: ".announcement__text",
			announcementClose: ".announcement__close"
		},
			n = {
				opening: "announcement--opening",
				closed: "announcement--closed"
			},
			a = {
				namespace: ".announcementBar"
			};

		function o() {
			t(e.announcementBar).removeClass(n.closed), s()
		}

		function s() {
			var a = t(e.announcementText).outerHeight(!0);
			t(e.announcementBar).addClass(n.opening).prepareTransition().css({
				height: a
			}), t(e.announcementClose).css({
				height: a
			})
		}

		function r() {
			return t(e.announcementText).data("text")
		}
		return {
			init: function c() {
				t(e.announcementClose).length && (theme.config.hasSessionStorage && "hidden" !== sessionStorage[r()] && window.setTimeout(function () {
					o()
				}, 2e3), theme.config.hasSessionStorage || window.setTimeout(function () {
					o()
				}, 2e3), t(e.announcementClose).on("click", function (a) {
					a.preventDefault(), theme.config.hasSessionStorage && sessionStorage.setItem(r(), "hidden"), t(e.announcementBar).height(), t(e.announcementBar).addClass(n.closed)
				}), t(window).on("resize" + a.namespace, t.debounce(150, s)))
			},
			unload: function e() {
				t(window).off(a.namespace)
			}
		}
	}(), theme.currencySwitcher = function () {
		var e = {
			dataDiv: "#CurrencyData",
			picker: ".currency-input"
		},
			n = {};

		function a() {
			var n = t(e.picker).val();
			Currency.convertAll(Currency.currentCurrency, n)
		}
		return {
			init: function o() {
				var s, r = t(e.dataDiv);
				if (r.length) {
					$primaryPicker = t("#CurrencyPicker-header"), $drawerPicker = t("#CurrencyPicker-drawer"), $primaryPicker.on("change", function () {
						$drawerPicker.val(t(this).val())
					}), $drawerPicker.on("change", function () {
						$primaryPicker.val(t(this).val())
					}), n = {
						currency: r.data("shop-currency"),
						default: r.data("default-currency"),
						format: r.data("format"),
						moneyFormat: r.data("money-format"),
						moneyCurrencyFormat: r.data("money-currency-format")
					}, Currency.format = n.format, Currency.money_format[n.currency] = n.moneyFormat, Currency.money_with_currency_format[n.currency] = n.moneyCurrencyFormat, t("span.money span.money").each(function () {
						t(this).parents("span.money").removeClass("money")
					}), t("span.money").each(function () {
						t(this).attr("data-currency-" + n.currency, t(this).html())
					}), null == (s = Currency.cookie.read()) ? n.currency !== n.default ? Currency.convertAll(n.currency, n.default) : Currency.currentCurrency = n.default : t(e.picker).length && 0 === t(e.picker).find("option[value=" + s + "]").length ? (Currency.currentCurrency = n.currency, Currency.cookie.write(n.currency)) : s === n.currency ? Currency.currentCurrency = n.currency : Currency.convertAll(n.currency, s), t(e.picker).val(Currency.currentCurrency).on("change", a)
				}
			},
			refresh: a,
			ajaxrefresh: function a() {
				var o = t(e.picker).val();
				Currency.convertAll(n.currency, o)
			}
		}
	}(), theme.initQuickShop = function (e) {
		var n = [];
		t(".quick-product__btn").each(function () {
			var e = t(this).data("product-id");
			if (n.indexOf(e) > -1) {
				t('.modal--quick-shop[data-product-id="' + e + '"]').each(function (e) {
					e > 0 && t(this).remove()
				});
				return
			}
			new theme.Modals("QuickShopModal-" + e, "quick-modal-" + e), n.push(e)
		})
	}, theme.videoModal = function () {
		var e = {
			width: 1280,
			height: 720,
			playerVars: {
				autohide: 0,
				autoplay: 1,
				branding: 0,
				cc_load_policy: 0,
				fs: 0,
				iv_load_policy: 3,
				modestbranding: 1,
				playsinline: 1,
				quality: "hd720",
				rel: 0,
				showinfo: 0,
				wmode: "opaque"
			}
		},
			n = {
				triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
			};
		if (t(n.triggers).length) {
			var a = new theme.Modals("VideoModal", "video-modal", {
				closeOffContentClick: !0,
				solid: !0
			});
			t(n.triggers).on("click", function e(n) {
				n.preventDefault(), window.loadYouTube(), theme.config.youTubeReady ? o(n) : t("body").on("youTubeReady", function () {
					o(n)
				})
			})
		}

		function o(n) {
			var o, s, r, c = (o = t(n.target).attr("href"), s = o.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/), !!s && 11 == s[7].length && s[7]),
				d = t.extend({}, e, {
					videoId: c
				});
			d.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
			var l = new YT.Player("VideoHolder", d);
			a.open(), t("body").on("modalClose.VideoModal", function () {
				setTimeout(function () {
					l.destroy()
				}, 500)
			})
		}
	}, theme.customerTemplates = function () {
		function e() {
			t("#RecoverPasswordForm").toggleClass("hide"), t("#CustomerLoginForm").toggleClass("hide")
		}
		return {
			init: function () {
				var n, a;
				"#recover" === window.location.hash && e(), t("#RecoverPassword").on("click", function (t) {
					t.preventDefault(), e()
				}), t("#HideRecoverPasswordLink").on("click", function (t) {
					t.preventDefault(), e()
				}), t(".reset-password-success").length && t("#ResetSuccess").removeClass("hide"), n = t("#AddressNewForm"), a = t(".js-address-form"), n.length && a.length && (Shopify && t(".js-address-country").each(function () {
					var e = t(this),
						n = e.data("country-id"),
						a = e.data("province-id"),
						o = e.data("province-container-id");
					new Shopify.CountryProvinceSelector(n, a, {
						hideElement: o
					})
				}), t(".address-new-toggle").on("click", function () {
					n.toggleClass("hide")
				}), t(".address-edit-toggle").on("click", function () {
					var e = t(this).data("form-id");
					t("#EditAddress_" + e).toggleClass("hide")
				}), t(".address-delete").on("click", function () {
					var e = t(this),
						n = e.data("form-id");
					confirm(e.data("confirm-message") || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + n, {
						parameters: {
							_method: "delete"
						}
					})
				}))
			}
		}
	}(), theme.Product = function () {
		var e, n, a = {
			onSale: "on-sale",
			disabled: "disabled",
			isModal: "is-modal",
			loading: "loading",
			loaded: "loaded",
			interactable: "video-interactable",
			zoomInit: "photo-zoom-init"
		},
			o = {
				productVideo: ".product__video",
				videoParent: ".product__video-wrapper",
				currentSlide: ".slick-current",
				zoomImage: ".photo-zoom-link__initial"
			},
			s = {},
			r = [],
			c = {
				height: "480",
				width: "850",
				playerVars: {
					autohide: 0,
					autoplay: 1,
					branding: 0,
					cc_load_policy: 0,
					controls: 0,
					fs: 0,
					iv_load_policy: 3,
					modestbranding: 1,
					playsinline: 1,
					quality: "hd720",
					rel: 0,
					showinfo: 0,
					wmode: "opaque"
				},
				events: {
					onReady: function e(n) {
						var a = t(n.target.a),
							c = a.attr("id");
						r[c] = n.target, r[c], p(a), "muted" === s[c].style ? r[c].mute().playVideo().pauseVideo() : f(a), (a.closest(o.currentSlide).length || 1 === a.data("image-count")) && "muted" === s[c].style && (r[c].playVideo(), u(c))
					},
					onStateChange: function e(n) {
						var c = t(n.target.a),
							d = c.attr("id"),
							l = r[d];
						switch (n.data) {
							case -1:
								s[d].attemptedToPlay && (f(c), function t(e) {
									e.closest(o.videoParent).addClass(a.interactable)
								}(c));
								break;
							case 0:
								l.playVideo();
								break;
							case 1:
								f(c);
								break;
							case 3:
								s[d].attemptedToPlay = !0
						}
					}
				}
			},
			d = [],
			l = {
				byline: !1,
				title: !1,
				portrait: !1,
				loop: !0
			};

		function u(e) {
			h(e), t(window).on("scroll." + e, {
				id: e
			}, t.throttle(150, h))
		}

		function h(e) {
			var n, a, o;
			if (n = "string" == typeof e ? e : e.data.id, theme.isElementVisible(t("#" + n))) {
				if (s[n] && "unmuted" === s[n].style) return;
				a = n, r[a] && "function" == typeof r[a].playVideo && r[a].playVideo()
			} else {
				o = n, r[o] && "function" == typeof r[o].pauseVideo && r[o].pauseVideo()
			}
		}

		function p(t) {
			t.closest(o.videoParent).addClass(a.loading)
		}

		function f(t) {
			t.closest(o.videoParent).removeClass(a.loading).addClass(a.loaded)
		}

		function m(e) {
			var n = this.$container = t(e),
				a = this.sectionId = n.attr("data-section-id");
			this.inModal = n.closest(".modal").length, this.$modal, this.settings = {
				enableHistoryState: n.data("enable-history-state") || !1,
				namespace: ".product-" + a,
				zoom: n.data("image-zoom") || !1,
				inventory: n.data("inventory") || !1,
				modalInit: !1,
				lazyLoadModalContent: n.data("lazyload-content") || !1,
				slickInitialized: !1,
				hasImages: !0,
				hasMultipleImages: !1,
				imageSize: "620x"
			}, this.inModal && (this.settings.enableHistoryState = !1, this.settings.namespace = ".product-" + a + "-modal", this.$modal = t("#QuickShopModal-" + a)), this.selectors = {
				productJson: "ProductJson-" + a,
				video: "ProductVideo-" + a,
				photoThumbs: ".product__thumb-" + a,
				thumbSlider: "#ProductThumbs-" + a,
				mainSlider: "#ProductPhotos-" + a,
				productImageMain: ".product-image-main--" + a,
				priceWrapper: ".product__price-wrap-" + a,
				price: "#ProductPrice-" + a,
				comparePrice: "#ComparePrice-" + a,
				priceA11y: "#PriceA11y-" + a,
				comparePriceA11y: "#ComparePriceA11y-" + a,
				sku: "#Sku-" + a,
				inventory: "#ProductInventory-" + a,
				addToCart: "#AddToCart-" + a,
				addToCartText: "#AddToCartText-" + a,
				originalSelectorId: "#ProductSelect-" + a,
				singleOptionSelector: ".variant__input-" + a,
				variantColorSwatch: ".variant__input--color-swatch-" + a,
				modalFormHolder: "#ProductFormHolder-" + a,
				formContainer: "#AddToCartForm-" + a
			}, t("#" + this.selectors.productJson).html() && (this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML), this.$mainSlider = t(this.selectors.mainSlider), this.$thumbSlider = t(this.selectors.thumbSlider), this.$firstProductImage = this.$mainSlider.find("img").first(), this.$firstProductImage.length || (this.settings.hasImages = !1), this.init())
		}
		return m.prototype = t.extend({}, m.prototype, {
			init: function () {
				this.inModal && (this.$container.addClass(a.isModal), t("body").on("modalOpen.QuickShopModal-" + this.sectionId, this.openModalProduct.bind(this)), t("body").on("modalClose.QuickShopModal-" + this.sectionId, this.closeModalProduct.bind(this))), this.inModal || (this.stringOverrides(), this.formSetup(), this.productSetup(), this.checkIfVideos(), this.createImageCarousels())
			},
			formSetup: function () {
				this.initQtySelector(), this.initAjaxProductForm(), this.initVariants()
			},
			productSetup: function () {
				this.setImageSizes(), this.initImageSwitch()
			},
			stringOverrides: function () {
				theme.productStrings = theme.productStrings || {}, t.extend(theme.strings, theme.productStrings)
			},
			setImageSizes: function () {
				if (this.settings.hasImages) {
					var t = this.$firstProductImage[0].currentSrc;
					t && (this.settings.imageSize = theme.Images.imageSize(t)), this.settings.zoom && (this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data("zoom-size")))
				}
			},
			initVariants: function () {
				var e = {
					$container: this.$container,
					enableHistoryState: this.settings.enableHistoryState,
					singleOptionSelector: this.selectors.singleOptionSelector,
					originalSelectorId: this.selectors.originalSelectorId,
					product: this.productObject
				};
				t(this.selectors.variantColorSwatch).length && t(this.selectors.variantColorSwatch).on("change", (function (e) {
					var n = t(e.currentTarget),
						a = n.data("color-name"),
						o = n.data("color-index");
					this.updateColorName(a, o)
				}).bind(this)), this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this)), t(this.selectors.sku).length && this.$container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this)), this.settings.inventory && this.$container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this))
			},
			updateColorName: function (e, n) {
				t("#VariantColorLabel-" + this.sectionId + "-" + n).text(e)
			},
			updateCartButton: function (e) {
				var n = e.variant;
				n ? n.available ? (t(this.selectors.addToCart).removeClass(a.disabled).prop("disabled", !1), t(this.selectors.addToCartText).html(theme.strings.addToCart)) : (t(this.selectors.addToCart).addClass(a.disabled).prop("disabled", !0), t(this.selectors.addToCartText).html(theme.strings.soldOut)) : (t(this.selectors.addToCart).addClass(a.disabled).prop("disabled", !0), t(this.selectors.addToCartText).html(theme.strings.unavailable))
			},
			updatePrice: function (e) {
				var n = e.variant;
				n && (t(this.selectors.price).html(theme.Currency.formatMoney(n.price, theme.settings.moneyFormat)).show(), n.compare_at_price > n.price ? (t(this.selectors.comparePrice).html(theme.Currency.formatMoney(n.compare_at_price, theme.settings.moneyFormat)), t(this.selectors.priceWrapper).removeClass("hide"), t(this.selectors.price).addClass(a.onSale), t(this.selectors.comparePriceA11y).attr("aria-hidden", "false"), t(this.selectors.priceA11y).attr("aria-hidden", "false")) : (t(this.selectors.priceWrapper).addClass("hide"), t(this.selectors.price).removeClass(a.onSale), t(this.selectors.comparePriceA11y).attr("aria-hidden", "true"), t(this.selectors.priceA11y).attr("aria-hidden", "true")), t("body").hasClass("currencies-enabled") && theme.currencySwitcher.ajaxrefresh())
			},
			updateSku: function (e) {
				var n = e.variant,
					a = "";
				n && (n.sku && (a = n.sku), t(this.selectors.sku).html(a))
			},
			updateInventory: function (e) {
				var n = e.variant,
					a = !1,
					o = 0,
					s = t(this.selectors.inventory);
				n && "shopify" === n.inventory_management && (a = !0, 0 === (o = window.inventories[this.sectionId][n.id]) && (a = !1)), a ? s.removeClass("hide").text(theme.strings.stockLabel.replace("[count]", o)) : s.addClass("hide")
			},
			updateVariantImage: function (e) {
				var n, a = e.variant;
				theme.Images.getSizedImageUrl(a.featured_image.src, this.settings.imageSize), this.settings.zoom && (n = theme.Images.getSizedImageUrl(a.featured_image.src, this.settings.imageZoomSize));
				var o = t('.product__thumb[data-id="' + a.featured_image.id + '"]'),
					s = this._slideIndex(o.closest(".product__thumb-item"));
				void 0 !== s && this.$mainSlider.slick("slickGoTo", s)
			},
			initImageSwitch: function () {
				t(this.selectors.photoThumbs).length && t(this.selectors.photoThumbs).on("click", function (t) {
					t.preventDefault()
				})
			},
			checkIfVideos: function () {
				var e = this.$mainSlider.find(o.productVideo);
				if (!e.length) return !1;
				var a = [];
				return e.each(function () {
					var e = t(this).data("video-type");
					0 > a.indexOf(e) && a.push(e)
				}), a.indexOf("youtube") > -1 && (theme.config.youTubeReady ? this.loadYoutubeVideos(e) : (window.loadYouTube(), t("body").on("youTubeReady" + this.settings.namespace, (function () {
					this.loadYoutubeVideos(e)
				}).bind(this)))), a.indexOf("vimeo") > -1 && (n ? this.loadVimeoVideos(e) : (window.loadVimeo(), t("body").on("vimeoReady" + this.settings.namespace, (function () {
					this.loadVimeoVideos(e)
				}).bind(this)))), a.indexOf("mp4") > -1 && this.loadMp4Videos(e), a
			},
			loadMp4Videos: function (e) {
				e.each(function () {
					var e = t(this);
					if ("mp4" == e.data("video-type")) {
						var n = e.attr("id");
						e.data("video-id"), s[this.id] = {
							type: "mp4",
							divId: n,
							style: e.data("video-style")
						}
					}
				})
			},
			loadVimeoVideos: function (e) {
				for (var a in e.each(function () {
					var e = t(this);
					if ("vimeo" == e.data("video-type")) {
						var n = e.attr("id"),
							a = e.data("video-id");
						s[this.id] = {
							type: "vimeo",
							divId: n,
							id: a,
							style: e.data("video-style"),
							width: e.data("video-width"),
							height: e.data("video-height")
						}
					}
				}), s)
					if ("vimeo" == s[a].type) {
						var o = t.extend({}, l, s[a]);
						d[a] = new Vimeo.Player(s[a].divId, o)
					} n = !0
			},
			autoplayVimeoVideo: function (e) {
				if (theme.config.bpSmall) {
					var n = t("#" + e);
					f(n)
				} else this.requestToPlayVimeoVideo(e)
			},
			requestToPlayVimeoVideo: function (e) {
				var a = t("#" + e);
				if (p(a), !n) {
					t("body").on("vimeoReady" + this.settings.namespace, (function () {
						this.playVimeoVideo(e)
					}).bind(this));
					return
				}
				this.playVimeoVideo(e)
			},
			playVimeoVideo: function (e) {
				d[e].play(), "muted" === s[e].style && d[e].setVolume(0);
				var n = t("#" + e);
				f(n)
			},
			stopVimeoVideo: function (t) {
				if (theme.config.vimeoReady) {
					if (t) d[t].pause();
					else
						for (key in d) "function" == typeof d[key].pause && d[key].pause()
				}
			},
			loadYoutubeVideos: function (n) {
				for (var a in n.each(function () {
					var e = t(this);
					if ("youtube" == e.data("video-type")) {
						var n = e.attr("id"),
							a = e.data("youtube-id");
						s[this.id] = {
							type: "youtube",
							id: n,
							videoId: a,
							style: e.data("video-style"),
							width: e.data("video-width"),
							height: e.data("video-height"),
							attemptedToPlay: !1
						}
					}
				}), s)
					if ("youtube" === s[a].type && s.hasOwnProperty(a)) {
						var o = t.extend({}, c, s[a]);
						"muted" === o.style || (o.playerVars.controls = 1, o.playerVars.autoplay = 0), r[a] = new YT.Player(a, o)
					} e = !0
			},
			requestToPlayYoutubeVideo: function (e, n) {
				if (theme.config.youTubeReady) {
					var a = t("#" + e);
					if (p(a), "function" != typeof r[e].playVideo) {
						var o = this;
						setTimeout(function () {
							o.playYoutubeVideo(e, n)
						}, 1e3);
						return
					}
					this.playYoutubeVideo(e, n)
				}
			},
			playYoutubeVideo: function (e, n) {
				var a = t("#" + e);
				f(a), "function" == typeof r[e].playVideo && r[e].playVideo(), n || u(e)
			},
			stopYoutubeVideo: function (e) {
				if (theme.config.youTubeReady) {
					if (e && r[e]) "function" == typeof r[e].pauseVideo && r[e].pauseVideo(), t(window).off("scroll." + e);
					else
						for (key in r) "function" == typeof r[key].pauseVideo && (r[key].pauseVideo(), t(window).off("scroll." + key))
				}
			},
			playMp4Video: function (e) {
				var n = t("#" + e);
				f(n), n[0].play()
			},
			stopMp4Video: function (e) {
				if (e) t("#" + e)[0].pause();
				else
					for (var n in s)
						if ("mp4" === s[n].type) {
							var a = t("#" + s[n].divId)[0];
							"function" == typeof a.pause && a.pause()
						}
			},
			initZoom: function (e) {
				var n = e.parent().data("zoom-size");
				e.parent().on("click", function (t) {
					t.preventDefault()
				}).zoom({
					on: "click",
					url: n,
					duration: 180,
					touch: !1,
					onZoomIn: function () {
						t(this).addClass("photo-zoom-linked")
					},
					onZoomOut: function () {
						t(this).removeClass("photo-zoom-linked")
					}
				})
			},
			createImageCarousels: function () {
				if (!this.$thumbSlider.length || t(this.selectors.photoThumbs).length < 2) {
					var e = t(this.selectors.productImageMain).find(o.productVideo);
					e.length && this.initVideo(e), this.settings.zoom && this.initZoom(t(this.selectors.productImageMain).find(o.zoomImage));
					return
				}
				this.settings.hasMultipleImages = !0;
				var n = this.$mainSlider.find(".starting-slide"),
					a = this._slideIndex(n);
				this.$mainSlider.off("init"), this.$mainSlider.off("beforeChange"), this.$mainSlider.on("init", this.mainSlideInit.bind(this)), this.$mainSlider.on("beforeChange", this.beforeSlideChange.bind(this));
				var s = "beside" === this.$thumbSlider.data("position");
				this.$mainSlider.slick({
					adaptiveHeight: !s,
					asNavFor: this.selectors.thumbSlider,
					infinite: !1,
					arrows: !1,
					dots: !1,
					initialSlide: a
				}), this.$thumbSlider.slick({
					asNavFor: this.selectors.mainSlider,
					slidesToShow: s ? 3 : 5,
					slidesToScroll: 1,
					arrows: !1,
					dots: !1,
					vertical: s,
					verticalSwiping: s,
					focusOnSelect: !0,
					infinite: !1,
					customHeightMatching: s,
					customSlideAdvancement: !0,
					initialSlide: a
				}), AOS && AOS.refresh(), this.settings.slickInitialized = !0
			},
			destroyImageCarousels: function () {
				this.settings.slickInitialized && (this.$mainSlider && this.$mainSlider.slick("unslick"), this.$thumbSlider && this.$thumbSlider.slick("unslick"), this.settings.slickInitialized = !1)
			},
			mainSlideInit: function (t, e) {
				var n = e.$slider.find(o.currentSlide).find(o.productVideo);
				n.length && this.initVideo(n)
			},
			initVideo: function (a) {
				var o = a.data("video-type"),
					r = a.attr("id");
				"mp4" === o && "muted" === s[r].style && this.playMp4Video(r), "youtube" === o && e && "muted" === s[r].style && this.requestToPlayYoutubeVideo(r), "vimeo" === o && (n ? this.playOrShowVimeo(r) : t("body").on("vimeoReady" + this.settings.namespace, (function () {
					this.playOrShowVimeo(r)
				}).bind(this))), this.inModal && this.resizeSlides()
			},
			playOrShowVimeo: function (e) {
				s[e] && "muted" === s[e].style ? this.autoplayVimeoVideo(e) : s[e] && "unmuted" === s[e].style && f(t("#" + e))
			},
			getVideoType: function (t) {
				return t.data("video-type")
			},
			getVideoId: function (t) {
				return t.attr("id")
			},
			beforeSlideChange: function (r, c, d, l) {
				var u = c.$slider,
					h = u.find(o.currentSlide).find(".product__video"),
					p = u.find('.slick-slide[data-slick-index="' + l + '"]'),
					m = p.find(".product__video");
				if (d !== l && h.length) {
					var g = this.getVideoType(h),
						v = this.getVideoId(h);
					v && ("youtube" === g && this.stopYoutubeVideo(v), "mp4" === g && this.stopMp4Video(v), "vimeo" === g && this.stopVimeoVideo(v))
				}
				if (m.length) {
					var y = this.getVideoType(m),
						b = this.getVideoId(m);
					b && "vimeo" === y && (n ? s[b] && "muted" === s[b].style && this.autoplayVimeoVideo(b) : t("body").on("vimeoReady" + this.settings.namespace, (function () {
						s[b] && "muted" === s[b].style && this.autoplayVimeoVideo(b)
					}).bind(this))), b && "youtube" === y && (e ? s[b] && "muted" === s[b].style && this.requestToPlayYoutubeVideo(b, !0) : t("body").on("youTubeReady" + this.settings.namespace, (function () {
						s[b] && "muted" === s[b].style && this.requestToPlayYoutubeVideo(b, !0)
					}).bind(this))), b && s[b] && "muted" === s[b].style && "mp4" === y && this.playMp4Video(b), b && s[b] && "muted" != s[b].style && f(t("#" + b))
				}
				if (this.settings.zoom) {
					if (p.hasClass(a.zoomInit)) return;
					var C = p.addClass(a.zoomInit).find("img").addClass("lazyload");
					this.initZoom(C)
				}
			},
			resizeSlides: function () {
				this.settings.hasMultipleImages && (t(window).trigger("resize"), setTimeout((function () {
					this.$mainSlider.slick("setPosition"), this.$thumbSlider.slick("setPosition")
				}).bind(this), 500))
			},
			_slideIndex: function (t) {
				return t.data("index")
			},
			initQtySelector: function () {
				this.$container.find(".js-qty").each(function () {
					new theme.QtySelector(t(this), {
						namespace: ".product"
					})
				})
			},
			initAjaxProductForm: function () {
				"drawer" === theme.settings.cartType && new theme.AjaxProduct(t(this.selectors.formContainer))
			},
			openModalProduct: function () {
				if (!this.settings.modalInit) {
					var e = t(this.selectors.modalFormHolder),
						n = e.data("url");
					e.load(n + " #AddToCartForm-" + this.sectionId, (function () {
						this.formSetup(), Shopify.PaymentButton && Shopify.PaymentButton.init()
					}).bind(this)), this.productSetup(), this.loadModalContent(), this.createImageCarousels(), this.settings.modalInit = !0
				}
				this.resizeSlides()
			},
			closeModalProduct: function () {
				this.stopYoutubeVideo(), this.stopVimeoVideo(), this.stopMp4Video()
			},
			loadModalContent: function () {
				var e = this.checkIfVideos();
				e && e.indexOf("mp4") > -1 && this.$modal.find('.product__video[data-video-type="mp4"]').each((function (e, n) {
					var a = t(n),
						o = a.data("video-src"),
						s = document.createElement("source");
					s.setAttribute("src", o), a.append(s)
				}).bind(this))
			},
			onUnload: function () {
				this.$container.off(this.settings.namespace), t("body").off(this.settings.namespace), this.destroyImageCarousels()
			}
		}), m
	}(), theme.Collection = function () {
		var e = {
			tags: ".tags",
			activeTag: "tag--active"
		};

		function n(e) {
			this.container = e, this.sectionId = t(e).attr("data-section-id"), this.namespace = ".collection-" + this.sectionId;
			var n = t(e).find(".collection-hero");
			n.length && theme.loadImageSection(n), t(window).on("popstate", (function (t) {
				t && this.getNewCollectionContent(location.href)
			}).bind(this)), this.init()
		}
		return n.prototype = t.extend({}, n.prototype, {
			init: function () {
				this.$container = t(this.container), this.sectionId = this.$container.attr("data-section-id"), this.sortBy(), this.sortTags(), this.initTagAjax()
			},
			initTagAjax: function () {
				this.$container.on("click" + this.namespace, ".tags a", (function (n) {
					n.preventDefault();
					var a = t(n.currentTarget),
						o = a.attr("href");
					t(e.tags).find("." + e.activeTag).removeClass(e.activeTag), a.parent().addClass(e.activeTag), history.pushState({}, "", o), t(".grid-product").addClass("unload"), this.getNewCollectionContent(o)
				}).bind(this))
			},
			getNewCollectionContent: function (e) {
				t("#CollectionAjaxResult").load(e + " #CollectionAjaxContent", (function () {
					this.reInit()
				}).bind(this))
			},
			sortBy: function () {
				var e = t("#SortBy");
				e.length && e.on("change", function () {
					location.href = "?sort_by=" + t(this).val()
				})
			},
			sortTags: function () {
				var e = t("#SortTags");
				e.length && e.on("change", function () {
					location.href = t(this).val()
				})
			},
			reInit: function () {
				for (var t = 0; t < sections.instances.length; t++) {
					var e = sections.instances[t];
					"collection-template" === e.type && e.forceReload()
				}
				AOS.refreshHard(), theme.initQuickShop(!0), sections.register("product-template", theme.Product)
			},
			forceReload: function () {
				this.onUnload(), this.init()
			},
			onUnload: function () {
				t(window).off(this.namespace), this.$container.off(this.namespace)
			}
		}), n
	}(), theme.HeaderSection = function () {
		var e = {
			drawer: "#NavDrawer",
			mobileSubNavToggle: ".mobile-nav__toggle-btn",
			hasSublist: ".mobile-nav__has-sublist"
		},
			n = {
				navExpanded: "mobile-nav--expanded"
			};

		function a(e) {
			var n = this.$container = t(e);
			this.sectionId = n.attr("data-section-id");
			for (var a = 0; a < sections.instances.length; a++) {
				var o = sections.instances[a];
				"slideshow-section" === o.type && o.forceReload()
			}
			theme.currencySwitcher.init(), this.initDrawers(), theme.headerNav.init(), theme.announcementBar.init()
		}
		return a.prototype = t.extend({}, a.prototype, {
			initDrawers: function () {
				theme.NavDrawer = new theme.Drawers("NavDrawer", "nav"), "drawer" === theme.settings.cartType && new theme.CartDrawer, this.drawerMenuButtons()
			},
			drawerMenuButtons: function () {
				t(e.drawer).find(".js-drawer-close").on("click", function (t) {
					t.preventDefault(), theme.NavDrawer.close()
				});
				var a = t(e.mobileSubNavToggle);
				a.attr("aria-expanded", "false"), a.each(function (e, n) {
					var a = t(n);
					a.attr("aria-controls", a.attr("data-aria-controls"))
				}), a.on("click", function () {
					var a = t(this),
						o = a.attr("aria-expanded"),
						s = !1;
					"true" === o ? a.attr("aria-expanded", "false") : (a.attr("aria-expanded", "true"), s = !0), a.closest(e.hasSublist).toggleClass(n.navExpanded, s)
				})
			},
			onUnload: function () {
				theme.NavDrawer.close(), theme.headerNav.unload(), theme.announcementBar.unload()
			}
		}), a
	}(), theme.FeaturedContentSection = function e() {
		t(".rte").find("a:not(:has(img))").addClass("text-link")
	}, theme.slideshows = {}, theme.SlideshowSection = function () {
		function e(e) {
			var n = this.$container = t(e);
			n.parent();
			var a = n.attr("data-section-id");
			this.slideshow = "#Slideshow-" + a;
			var o = t(e).find(".hero");
			o.length && theme.loadImageSection(o), this.init()
		}
		return e.prototype = t.extend({}, e.prototype, {
			init: function () {
				var e = {
					arrows: t(this.slideshow).data("arrows"),
					dots: t(this.slideshow).data("dots")
				};
				theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, e)
			},
			forceReload: function () {
				this.onUnload(), this.init()
			},
			onUnload: function () {
				theme.slideshows[this.slideshow].destroy(), delete theme.slideshows[this.slideshow]
			},
			onSelect: function () {
				t(this.slideshow).slick("slickPause")
			},
			onDeselect: function () {
				t(this.slideshow).slick("slickPlay")
			},
			onBlockSelect: function (e) {
				var n = t(this.slideshow),
					a = t(".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
				n.slick("slickGoTo", a).slick("slickPause")
			},
			onBlockDeselect: function () {
				t(this.slideshow).slick("slickPlay")
			}
		}), e
	}(), theme.VideoSection = function () {
		var e, n = [],
			a = [],
			o = {
				width: 1280,
				height: 720,
				playerVars: {
					autohide: 0,
					branding: 0,
					cc_load_policy: 0,
					controls: 0,
					fs: 0,
					iv_load_policy: 3,
					modestbranding: 1,
					playsinline: 1,
					quality: "hd720",
					rel: 0,
					showinfo: 0,
					wmode: "opaque"
				},
				events: {
					onReady: function e(n) {
						var o = t(n.target.a),
							s = o.attr("id");
						a[s] = n.target, a[s], h(o), a[s].mute(), o.attr("tabindex", "-1"), u(s), t(window).on("scroll." + s, {
							id: s
						}, t.throttle(150, u))
					},
					onStateChange: function e(o) {
						var s = t(o.target.a),
							r = s.attr("id"),
							c = a[r];
						switch (o.data) {
							case -1:
								n[r].attemptedToPlay && (p(s), f(s));
								break;
							case 0:
								c.playVideo();
								break;
							case 1:
								p(s);
								break;
							case 3:
								n[r].attemptedToPlay = !0
						}
					}
				}
			},
			s = !1,
			r = {
				byline: !1,
				title: !1,
				portrait: !1,
				loop: !0
			},
			c = {
				videoParent: ".video-parent-section"
			},
			d = {
				loading: "loading",
				loaded: "loaded",
				interactable: "video-interactable"
			};

		function l(e) {
			var n = this.$container = t(e);
			this.sectionId = n.attr("data-section-id");
			var a = this.youtubePlayerId = "YouTubeVideo-" + this.sectionId;
			this.namespace = "." + a;
			var o = this.vimeoPlayerId = "Vimeo-" + this.sectionId;
			this.$vimeoTrigger = t("#VimeoTrigger-" + this.sectionId);
			var s, r = "Mp4Video-" + this.sectionId,
				c = t("#" + a),
				d = t("#" + o),
				l = t("#" + r);
			this.vimeoPlayer = [], c.length && (this.youtubeVideoId = c.data("video-id"), this.initYoutubeVideo()), d.length && (this.vimeoVideoId = d.data("video-id"), this.initVimeoVideo()), l.length && (p(l), (s = r, document.querySelector("#" + s).play()).then(function () { }).catch(function (t) {
				f(l)
			}))
		}

		function u(e) {
			var n, o, s;
			n = "string" == typeof e ? e : e.data.id, theme.isElementVisible(t("#" + n)) ? (o = n, a[o] && "function" == typeof a[o].playVideo && a[o].playVideo()) : (s = n, a[s] && "function" == typeof a[s].pauseVideo && a[s].pauseVideo())
		}

		function h(t) {
			t.closest(c.videoParent).addClass(d.loading)
		}

		function p(t) {
			t.closest(c.videoParent).removeClass(d.loading).addClass(d.loaded)
		}

		function f(t) {
			t.closest(c.videoParent).addClass(d.interactable)
		}
		return l.prototype = t.extend({}, l.prototype, {
			initYoutubeVideo: function () {
				n[this.youtubePlayerId] = {
					id: this.youtubePlayerId,
					videoId: this.youtubeVideoId,
					type: "youtube",
					attemptedToPlay: !1
				}, e ? this.loadYoutubeVideo() : (window.loadYouTube(), t("body").on("youTubeReady" + this.namespace, this.loadYoutubeVideo.bind(this)))
			},
			loadYoutubeVideo: function () {
				var s = t.extend({}, o, n[this.youtubePlayerId]);
				s.playerVars.controls = 0, a[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, s), e = !0
			},
			initVimeoVideo: function () {
				n[this.vimeoPlayerId] = {
					divId: this.vimeoPlayerId,
					id: this.vimeoVideoId,
					type: "vimeo"
				};
				var e = t("#" + this.vimeoPlayerId);
				h(e), this.$vimeoTrigger.on("click", +this.namespace, (function (t) {
					this.requestToPlayVimeoVideo(this.vimeoPlayerId)
				}).bind(this)), s ? this.loadVimeoVideo() : (window.loadVimeo(), t("body").on("vimeoReady" + this.namespace, this.loadVimeoVideo.bind(this)))
			},
			loadVimeoVideo: function () {
				var e = t.extend({}, r, n[this.vimeoPlayerId]);
				if (this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(n[this.vimeoPlayerId].divId, e), s = !0, theme.config.bpSmall) {
					var a = t("#" + this.vimeoPlayerId);
					p(a)
				} else this.requestToPlayVimeoVideo(this.vimeoPlayerId)
			},
			requestToPlayVimeoVideo: function (e) {
				if (!s) {
					t("body").on("vimeoReady" + this.namespace, (function () {
						this.playVimeoVideo(e)
					}).bind(this));
					return
				}
				this.playVimeoVideo(e)
			},
			playVimeoVideo: function (e) {
				this.vimeoPlayer[e].play(), this.vimeoPlayer[e].setVolume(0);
				var n = t("#" + e);
				p(n)
			},
			onUnload: function (e) {
				var n;
				a["YouTubeVideo-" + e.target.id.replace("shopify-section-", "")].destroy(), t(window).off("scroll" + this.namespace), t("body").off("vimeoReady" + this.namespace)
			}
		}), l
	}(), theme.Testimonials = function () {
		var e = 0,
			n = {
				accessibility: !0,
				arrows: !1,
				dots: !0,
				autoplay: !1,
				touchThreshold: 20,
				slidesToShow: 3,
				slidesToScroll: 3
			};

		function a(a) {
			var o = (this.$container = t(a)).attr("data-section-id");
			this.wrapper = ".testimonials-wrapper";
			var s = t(this.slider = "#Testimonials-" + o);
			this.sliderActive = !1;
			var r = t.extend({}, n, {
				slidesToShow: 1,
				slidesToScroll: 1,
				adaptiveHeight: !0
			});
			(e = s.data("count")) < n.slidesToShow && (n.slidesToShow = e, n.slidesToScroll = e), s.on("init", this.a11y.bind(this)), theme.config.bpSmall ? this.init(s, r) : this.init(s, n), t("body").on("matchSmall", (function () {
				this.init(s, r)
			}).bind(this)), t("body").on("matchLarge", (function () {
				this.init(s, n)
			}).bind(this))
		}
		return a.prototype = t.extend({}, a.prototype, {
			onUnload: function () {
				t(this.slider, this.wrapper).slick("unslick")
			},
			onBlockSelect: function (e) {
				var n = t(".testimonials-slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
				t(this.slider, this.wrapper).slick("slickGoTo", n)
			},
			init: function (t, e) {
				this.sliderActive && (t.slick("unslick"), this.sliderActive = !1), t.slick(e), this.sliderActive = !0, AOS && AOS.refresh()
			},
			a11y: function (e, n) {
				var a = n.$list,
					o = t(this.wrapper, this.$container);
				a.removeAttr("aria-live"), o.on("focusin", function (t) {
					o.has(t.target).length && a.attr("aria-live", "polite")
				}), o.on("focusout", function (t) {
					o.has(t.target).length && a.removeAttr("aria-live")
				})
			}
		}), a
	}(), theme.Instagram = function () {
		function e(e) {
			var n = (this.$container = t(e)).attr("data-section-id"),
				a = t("#Instafeed-" + n);
			if (a.length) {
				var o = a.data("user-id"),
					s = a.data("client-id"),
					r = parseInt(a.data("count"));
				(this.feed = new Instafeed({
					target: a[0],
					accessToken: s,
					get: "user",
					userId: o,
					limit: r - 2,
					template: '<div class="grid__item small--one-half medium-up--one-fifth ins-padding" data-aos="row-of-4"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
					resolution: "standard_resolution"
				})).run()
			}
		}
		return e.prototype = t.extend({}, e.prototype, {
			onUnload: function () { }
		}), e
	}(), theme.NewsletterPopup = function () {
		function e(e) {
			var n = this.$container = t(e),
				a = n.attr("data-section-id");
			if (this.cookieName = "newsletter-" + a, n.length) {
				if (this.data = {
					secondsBeforeShow: n.data("delay-seconds"),
					daysBeforeReappear: n.data("delay-days"),
					cookie: t.cookie(this.cookieName),
					testMode: n.data("test-mode")
				}, this.modal = new theme.Modals("NewsletterPopup-" + a, "newsletter-popup-modal"), (n.find(".errors").length || n.find(".note--success").length) && this.modal.open(), n.find(".note--success").length) {
					this.closePopup();
					return
				}
				t("body").on("modalClose." + n.attr("id"), this.closePopup.bind(this)), (!this.data.cookie || this.data.testMode) && this.initPopupDelay()
			}
		}
		return e.prototype = t.extend({}, e.prototype, {
			initPopupDelay: function () {
				setTimeout((function () {
					this.modal.open()
				}).bind(this), 1e3 * this.data.secondsBeforeShow)
			},
			closePopup: function () {
				if (this.data.testMode) {
					t.removeCookie(this.cookieName, {
						path: "/"
					});
					return
				}
				t.cookie(this.cookieName, "opened", {
					path: "/",
					expires: this.data.daysBeforeReappear
				})
			},
			onLoad: function () {
				this.modal.open()
			},
			onSelect: function () {
				this.modal.open()
			},
			onDeselect: function () {
				this.modal.close()
			},
			onUnload: function () { }
		}), e
	}(), theme.FadingImages = function () {
		var e = {
			activeImage: "active-image",
			finishedImage: "finished-image",
			activeTitles: "active-titles",
			finishedTitles: "finished-titles",
			compensation: "compensation"
		};

		function n(e) {
			var n = this.$container = t(e),
				a = n.attr("data-section-id");
			if (this.namespace = ".fading-images-" + a, n.length) {
				var o = n.find(".fading-images");
				theme.loadImageSection(o), this.data = {
					isInit: !1,
					interval: n.data("interval"),
					block_count: n.data("count"),
					finish_interval: 1e3,
					timer_offset: 400,
					active_image: 1,
					active_title: 1,
					removed_compensation: !1
				}, this.selectors = {
					$allTitles: n.find(".fading-images-overlay__titles")
				}, this.checkVisibility(), t(window).on("scroll" + this.namespace, t.throttle(100, this.checkVisibility.bind(this)))
			}
		}
		return n.prototype = t.extend({}, n.prototype, {
			checkVisibility: function () {
				if (this.data.isInit) {
					t(window).off("scroll" + this.namespace);
					return
				}
				theme.isElementVisible(this.$container) && (this.startImages(), this.startTitles(), this.data.isInit = !0)
			},
			nextImage: function () {
				var t = this.$container;
				this.data.removed_compensation || (t.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").removeClass(e.compensation), this.data.removed_compensation = !0), t.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").removeClass(e.activeImage).addClass(e.finishedImage);
				var n = this.data.active_image;
				window.setTimeout(function () {
					t.find(".fading-images__item[data-slide-index=" + n + "]").removeClass(e.finishedImage)
				}, this.data.finish_interval), this.data.active_image++, this.data.active_image > this.data.block_count && (this.data.active_image = 1), t.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").addClass(e.activeImage)
			},
			nextTitle: function () {
				var t = this.$container,
					n = this.selectors.$allTitles;
				this.selectors.$allTitles.removeClass(e.activeTitles).addClass(e.finishedTitles), this.data.active_title++, this.data.active_title > this.data.block_count && (this.data.active_title = 1);
				var a = this.data.active_title;
				window.setTimeout(function () {
					var o = t.find(".fading-images__item[data-slide-index=" + a + "]").attr("data-slide-title1"),
						s = t.find(".fading-images__item[data-slide-index=" + a + "]").attr("data-slide-title2");
					t.find(".fading-images-overlay__title--1").text(o), t.find(".fading-images-overlay__title--2").text(s), n.removeClass(e.finishedTitles).addClass(e.activeTitles)
				}, this.data.finish_interval - 200)
			},
			startImages: function () {
				this.$container.find(".fading-images__item[data-slide-index=" + this.data.active_image + "]").addClass(e.activeImage).addClass(e.compensation);
				var t = this;
				window.setTimeout(function () {
					window.setInterval(t.nextImage.bind(t), t.data.interval)
				}, this.data.timer_offset)
			},
			startTitles: function () {
				var t = this.$container,
					n = this.selectors.$allTitles,
					a = this.data.active_title;
				window.setTimeout(function () {
					var o = t.find(".fading-images__item[data-slide-index=" + a + "]").attr("data-slide-title1"),
						s = t.find(".fading-images__item[data-slide-index=" + a + "]").attr("data-slide-title2");
					t.find(".fading-images-overlay__title--1").text(o), t.find(".fading-images-overlay__title--2").text(s), n.addClass(e.activeTitles)
				}, 750), window.setInterval(this.nextTitle.bind(this), this.data.interval)
			},
			onLoad: function () { },
			onSelect: function () { },
			onDeselect: function () { },
			onUnload: function () { }
		}), n
	}(), theme.Maps = function () {
		var e = {
			zoom: 14
		},
			n = null,
			a = [],
			o = {
				addressNoResults: theme.strings.addressNoResults,
				addressQueryLimit: theme.strings.addressQueryLimit,
				addressError: theme.strings.addressError,
				authError: theme.strings.authError
			},
			s = {
				section: '[data-section-type="map"]',
				map: "[data-map]",
				mapOverlay: "[data-map-overlay]"
			},
			r = {
				mapError: "map-section--load-error",
				errorMsg: "map-section__error errors text-center"
			};

		function c(e) {
			this.$container = t(e), this.sectionId = this.$container.attr("data-section-id"), this.namespace = ".map-" + this.sectionId, this.$map = this.$container.find(s.map), this.key = this.$map.data("api-key"), this.key && (this.checkVisibility(), t(window).on("scroll" + this.namespace, t.throttle(50, this.checkVisibility.bind(this))))
		}
		return window.gm_authFailure = function () {
			Shopify.designMode && (t(s.section).addClass(r.mapError), t(s.map).remove(), t(s.mapOverlay).after('<div class="' + r.errorMsg + '">' + theme.strings.authError + "</div>"))
		}, c.prototype = t.extend({}, c.prototype, {
			prepMapApi: function () {
				"loaded" === n ? this.createMap() : (a.push(this), "loading" !== n && (n = "loading", void 0 === window.google && t.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
					n = "loaded", t.each(a, function (t, e) {
						e.createMap()
					})
				})))
			},
			createMap: function () {
				var n, a, s, c, d = this.$map;
				return (n = d, a = t.Deferred(), s = new google.maps.Geocoder, c = n.data("address-setting"), s.geocode({
					address: c
				}, function (t, e) {
					e !== google.maps.GeocoderStatus.OK && a.reject(e), a.resolve(t)
				}), a).then((function (n) {
					var a = {
						zoom: e.zoom,
						backgroundColor: "none",
						center: n[0].geometry.location,
						draggable: !1,
						clickableIcons: !1,
						scrollwheel: !1,
						disableDoubleClickZoom: !0,
						disableDefaultUI: !0
					},
						o = this.map = new google.maps.Map(d[0], a),
						s = this.center = o.getCenter();
					new google.maps.Marker({
						map: o,
						position: o.getCenter()
					}), google.maps.event.addDomListener(window, "resize", t.debounce(250, function () {
						google.maps.event.trigger(o, "resize"), o.setCenter(s), d.removeAttr("style")
					}))
				}).bind(this)).fail(function () {
					var t;
					switch (status) {
						case "ZERO_RESULTS":
							t = o.addressNoResults;
							break;
						case "OVER_QUERY_LIMIT":
							t = o.addressQueryLimit;
							break;
						case "REQUEST_DENIED":
							t = o.authError;
							break;
						default:
							t = o.addressError
					}
					Shopify.designMode && d.parent().addClass(r.mapError).html('<div class="' + r.errorMsg + '">' + t + "</div>")
				})
			},
			checkVisibility: function () {
				theme.isElementVisible(this.$container, 600) && (this.prepMapApi(), t(window).off(this.namespace))
			},
			onUnload: function () {
				0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize")
			}
		}), c
	}(), theme.Blog = function () {
		function e(t) {
			this.tagFilters()
		}
		return e.prototype = t.extend({}, e.prototype, {
			tagFilters: function () {
				var e = t("#BlogTagFilter");
				e.length && e.on("change", function () {
					location.href = t(this).val()
				})
			},
			onUnload: function () { }
		}), e
	}(), theme.Photoswipe = function () {
		var e = {
			photoswipeImg: ".photoswipe__image"
		};

		function n(n) {
			var a = this.$container = t(n);
			a.attr("data-section-id"), this.namespace = ".photoswipe-" + this.sectionId, this.$images = a.find(e.photoswipeImg), this.gallery, a.length && this.init()
		}
		return n.prototype = t.extend({}, n.prototype, {
			init: function () {
				var e = [];
				this.$images.each(function () {
					var n = {
						msrc: t(this).prop("currentSrc") || t(this).prop("src"),
						src: t(this).data("photoswipe-src"),
						w: t(this).data("photoswipe-width"),
						h: t(this).data("photoswipe-height"),
						el: t(this)[0]
					};
					e.push(n)
				}), this.$images.on("click" + this.namespace, (function (n) {
					index = t(n.currentTarget).data("index"), this.initGallery(e, index)
				}).bind(this))
			},
			initGallery: function (t, e) {
				var n = document.querySelectorAll(".pswp")[0];
				this.gallery = new PhotoSwipe(n, PhotoSwipeUI_Default, t, {
					history: !1,
					index: e - 1,
					getThumbBoundsFn: function (e) {
						var n = window.pageYOffset || document.documentElement.scrollTop,
							a = t[e].el.getBoundingClientRect();
						return {
							x: a.left,
							y: a.top + n,
							w: a.width
						}
					}
				}), this.gallery.init()
			},
			onUnload: function () {
				this.$images.off("click" + this.namespace), this.gallery.destroy()
			}
		}), n
	}(), theme.config = {
		bpSmall: !1,
		hasSessionStorage: !0,
		mediaQuerySmall: "screen and (max-width: 589px)",
		mediaQueryMediumUp: "screen and (min-width: 590px)",
		youTubeReady: !1,
		vimeoReady: !1,
		vimeoLoading: !1,
		isTouch: !!("ontouchstart" in window || window.DocumentTouch && window.document instanceof DocumentTouch) || !!window.navigator.maxTouchPoints || !!window.navigator.msMaxTouchPoints
	}, window.onYouTubeIframeAPIReady = function () {
		theme.config.youTubeReady = !0, t("body").trigger("youTubeReady")
	}, window.loadYouTube = function () {
		if (!theme.config.youtubeReady) {
			var t = document.createElement("script");
			t.src = "https://www.youtube.com/iframe_api";
			var e = document.getElementsByTagName("script")[0];
			e.parentNode.insertBefore(t, e)
		}
	}, window.loadVimeo = function () {
		if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
			theme.config.vimeoLoading = !0;
			var e = document.createElement("script");
			e.src = "https://player.vimeo.com/api/player.js";
			var n, a, o, s = document.getElementsByTagName("script")[0];
			s.parentNode.insertBefore(e, s), (o = t.Deferred(), n = setInterval(function () {
				Vimeo && (clearInterval(n), clearTimeout(a), o.resolve())
			}, 500), a = setTimeout(function () {
				clearInterval(n), o.reject()
			}, 4e3), o).then(function () {
				theme.config.vimeoReady = !0, theme.config.vimeoLoading = !1, t("body").trigger("vimeoReady")
			}).fail(function () { })
		}
	}, theme.init = function () {
		theme.setGlobals(), theme.pageTransitions(), theme.initQuickShop(), theme.videoModal(), theme.articleImages.init(), theme.backButton.init(), theme.customerTemplates.init(), theme.collapsibles.init(), slate.rte.wrapTable(), slate.rte.wrapVideo(), AOS.init({
			easing: "ease-out-quad",
			once: !0,
			offset: 60,
			disableMutationObserver: !0
		}), t(document.documentElement).on("keyup.tab", function (e) {
			9 === e.keyCode && (t(document.documentElement).addClass("tab-outline"), t(document.documentElement).off("keyup.tab"))
		})
	}, theme.setGlobals = function () {
		theme.config.hasSessionStorage = theme.isSessionStorageSupported(), theme.config.isTouch && t("body").addClass("supports-touch"), enquire.register(theme.config.mediaQuerySmall, {
			match: function () {
				theme.config.bpSmall = !0, t("body").trigger("matchSmall")
			},
			unmatch: function () {
				theme.config.bpSmall = !1, t("body").trigger("unmatchSmall")
			}
		}), enquire.register(theme.config.mediaQueryMediumUp, {
			match: function () {
				t("body").trigger("matchLarge")
			},
			unmatch: function () {
				t("body").trigger("unmatchLarge")
			}
		})
	}, theme.loadImageSection = function (t) {
		function e() {
			t.removeClass("loading loading--delayed").addClass("loaded")
		}

		function n() {
			return t.find(".lazyloaded").length
		}
		if (t.find("svg").length || n() > 0) {
			e();
			return
		}
		var a = setInterval(function () {
			n() > 0 && (clearInterval(a), e())
		}, 80)
	}, theme.isSessionStorageSupported = function () {
		if (window.self !== window.top) return !1;
		var t = "test",
			e = window.sessionStorage;
		try {
			return e.setItem(t, "1"), e.removeItem(t), !0
		} catch (n) {
			return !1
		}
	}, theme.isElementVisible = function (t, e) {
		var n = t[0].getBoundingClientRect(),
			a = window.innerHeight || document.documentElement.clientHeight;
		return e = e || 0, n.bottom >= 0 && n.right >= 0 && n.top <= a + e && n.left <= (window.innerWidth || document.documentElement.clientWidth)
	}, theme.pageTransitions = function () {
		!0 == t("body").data("transitions") && (navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) && t("a").on("click", function () {
			window.setTimeout(function () {
				t("body").removeClass("unloading")
			}, 1200)
		}), t('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function () {
			t(this).addClass("js-no-transition")
		}), t("a:not(.js-no-transition)").bind("click", function (e) {
			if (e.metaKey) return !0;
			e.preventDefault(), t("body").addClass("unloading");
			var n = t(this).attr("href");
			window.setTimeout(function () {
				location.href = n
			}, 50)
		}), t("a.mobile-nav__link").bind("click", function () {
			theme.NavDrawer.close()
		}))
	}, window.onpageshow = function (e) {
		e.persisted && t("body").removeClass("unloading")
	}, window.onload = function () {
		if (0 != addToCartBtn.length) {
			let e = addToCartBtn[0].offsetTop;
			t(window).scroll(function () {
				window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				e < (document.documentElement.scrollTop || document.body.scrollTop) ? (t(".btn-out").addClass("fixed-bottom"), t(".btn-out").addClass("pc-fixed-bottom"), t("#fixed-bottom-block").addClass("fixed-bottom-block"), t(".shopify-payment-button__button").addClass("fixed-pay-bottom"), t(".shopify-payment-button__more-options").addClass("fixed-pay-bottom"), t(".product-single__title").addClass("fixed-name-bottom")) : (t(".btn-out").removeClass("fixed-bottom"), t(".btn-out").removeClass("pc-fixed-bottom"), t("#fixed-bottom-block").removeClass("fixed-bottom-block"), t(".shopify-payment-button__button").removeClass("fixed-pay-bottom"), t(".shopify-payment-button__more-options").removeClass("fixed-pay-bottom"), t(".product-single__title").removeClass("fixed-name-bottom"))
			})
		}
	}, t(document).ready(function () {
		t(".my-ins-item").click(function () {
			window.open("https://www.instagram.com/level8_official/")
		}), theme.init(), window.sections = new theme.Sections, sections.register("header-section", theme.HeaderSection), sections.register("slideshow-section", theme.SlideshowSection), sections.register("video-section", theme.VideoSection), sections.register("product", theme.Product), sections.register("product-template", theme.Product), sections.register("collection-template", theme.Collection), sections.register("featured-content-section", theme.FeaturedContentSection), sections.register("testimonials", theme.Testimonials), sections.register("instagram", theme.Instagram), sections.register("newsletter-popup", theme.NewsletterPopup), sections.register("fading-images", theme.FadingImages), sections.register("map", theme.Maps), sections.register("blog", theme.Blog), sections.register("photoswipe", theme.Photoswipe)
	})
}(theme.jQuery);
